// tslint:disable
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A calendar date without time. */
  Date: any;
  /** A calendar date with time. */
  DateTime: any;
  /** A duration of time in seconds. */
  Duration: any;
  /** A JSON value. */
  JSON: any;
};

/** An `AdminAppUser` enables a `Person` to access the system. */
export type AdminAppUser = Node & ProcessResource & Timestamped & {
  __typename?: 'AdminAppUser';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /**
   * Whether this `AdminAppUser` has been archived.
   *
   * `AdminAppUser`s can only be deleted after having been archived and retained for a certain amount
   * of time.
   *
   * Archived `AdminAppUser`s cannot sign in and access the system.
   */
  isArchived: Scalars['Boolean'];
  modifiedAt: Scalars['DateTime'];
  /** The `Person` this `AdminAppUser` belongs to. */
  person: Person;
  process: DataProcessingProcess;
  /** The roles of this `AdminAppUser`. */
  roles: Array<UserRole>;
};

/**
 * An event that contains information for auditing of the system, such as when certain actions where
 * invoked anb by whom.
 */
export type AuditEvent = Node & {
  __typename?: 'AuditEvent';
  /**
   * Additional details, relevant to this event. No guaranties are made about the content of this
   * field. It exists for the purpose of giving additional context to a human auditor.
   *
   * To ensure compliance with data protection requirements, this field is set to `null` 1 year
   * after this event was recorded.
   */
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  /** A set of resources which where relevant to the event, when it occurred. */
  resources: Array<Maybe<AuditResource>>;
  /** The date when this event was recorded. */
  time: Scalars['DateTime'];
  /** The type of this event. */
  type: AuditEventType;
};

export type AuditEventConnection = Connection & {
  __typename?: 'AuditEventConnection';
  edges: Array<AuditEventEdge>;
  pageInfo: PageInfo;
};

export type AuditEventEdge = Edge & {
  __typename?: 'AuditEventEdge';
  cursor: Scalars['String'];
  node: AuditEvent;
};

/** The type of an `AuditEvent`. */
export enum AuditEventType {
  CreateResource = 'CreateResource',
  DeleteResource = 'DeleteResource',
  UpdateResource = 'UpdateResource'
}

/** A resources which is relevant to an `AuditEvent`. */
export type AuditResource = Node & {
  __typename?: 'AuditResource';
  /** The classifier of this `AuditResource`. */
  classifier: AuditResourceClassifier;
  id: Scalars['ID'];
  /** The actual resource if it still exists. */
  resource?: Maybe<Node>;
  /** The id of the resource. */
  resourceId: Scalars['ID'];
  /** The typ of the resource. */
  resourceType: Scalars['String'];
};

/** A classifier which determines the relationship of an `AuditResource` to an `AuditEvent`. */
export enum AuditResourceClassifier {
  /** The resource is the actor which triggered the event. */
  Actor = 'Actor',
  /** The resource is the target of the event. */
  EventTarget = 'EventTarget',
  /** The resource is a container of the event target resource. */
  TargetContainer = 'TargetContainer'
}

/** Matcher for filtering `AuditResources`. */
export type AuditResourceMatcher = {
  /** The classifier a resources needs to have to match. */
  classifier: AuditResourceClassifier;
  /** The id a resources needs to have to match. */
  resourceId: Scalars['ID'];
};

/** A combination of `AuditResourceMatcher`. */
export type AuditResourceMatchers = {
  /** An event needs to match all of the matchers to be matched. */
  and?: InputMaybe<Array<AuditResourceMatcher>>;
  /** An event need to match at least one of the matchers to be matched. */
  or?: InputMaybe<Array<AuditResourceMatcher>>;
};

/** An interface to support paging through results. */
export type Connection = {
  /** The set of `Edge`s included in this connection. */
  edges: Array<Edge>;
  /** The `PageInfo` of this connection. */
  pageInfo: PageInfo;
};

export type Course = DeleteRestricted & Named & Node & Timestamped & {
  __typename?: 'Course';
  adminGroups: Array<CourseAdminGroup>;
  canBeDeleted: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  level: CourseLevel;
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  organization: Organization;
  parts: Array<CoursePart>;
};

export type CourseAdminFile = Node & ProcessResource & Timestamped & {
  __typename?: 'CourseAdminFile';
  adminGroup: CourseAdminGroup;
  createdAt: Scalars['DateTime'];
  eventAttendances: Array<CourseEventAttendance>;
  expenseReceipts: Array<ExpenseReceipt>;
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
  /** Whether this file has been rescinded. */
  isRescinded: Scalars['Boolean'];
  modifiedAt: Scalars['DateTime'];
  optionBookings: Array<CourseOptionBooking>;
  person: Person;
  process: DataProcessingProcess;
};

export type CourseAdminGroup = DeleteRestricted & Named & Node & Timestamped & {
  __typename?: 'CourseAdminGroup';
  adminFiles: Array<CourseAdminFile>;
  /** If this group is archived, the date and time at which it was archived. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  canBeDeleted: Scalars['Boolean'];
  course: Course;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /**
   * Whether this group is archived.
   *
   * Only **Admin** users can update this field.
   *
   * The following mutations cannot be called while a group is archived:
   *
   * - `updateCourseAdminGroup`, except to change `isArchived`
   * - `createCourseAdminFile`
   * - `updateCourseAdminFile`
   * - `createCourseOptionDescriptor`
   * - `updateCourseOptionDescriptor`
   * - `deleteCourseOptionDescriptor`
   *
   * The following REST endpoints cannot be called wile a group is archived:
   *
   * `api/courseAdminGroups/{adminGroupId}/expenseReceipts/generate`
   */
  isArchived: Scalars['Boolean'];
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  optionDescriptors: Array<CourseOptionDescriptor>;
  parts: Array<CoursePart>;
};

export type CourseConnection = Connection & {
  __typename?: 'CourseConnection';
  edges: Array<CourseEdge>;
  pageInfo: PageInfo;
};

export type CourseEdge = Edge & {
  __typename?: 'CourseEdge';
  cursor: Scalars['String'];
  node: Course;
};

export type CourseEvent = Named & Node & {
  __typename?: 'CourseEvent';
  endDate: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  part: CoursePart;
  startDate: Scalars['DateTime'];
};

export type CourseEventAttendance = Node & {
  __typename?: 'CourseEventAttendance';
  customDuration?: Maybe<Scalars['Duration']>;
  event: CourseEvent;
  id: Scalars['ID'];
};

export type CourseEventAttendanceInput = {
  customDuration?: InputMaybe<Scalars['Duration']>;
  id: Scalars['ID'];
};

export enum CourseLevel {
  Four = 'Four',
  Material = 'Material',
  One = 'One',
  Publications = 'Publications',
  Three = 'Three',
  TranslationSources = 'TranslationSources',
  Two = 'Two',
  Zero = 'Zero'
}

export type CourseOptionBooking = DeleteRestricted & Node & UpdateRestricted & {
  __typename?: 'CourseOptionBooking';
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  descriptor: CourseOptionDescriptor;
  expense: Expense;
  id: Scalars['ID'];
};

export type CourseOptionDescriptor = DeleteRestricted & Named & Node & UpdateRestricted & {
  __typename?: 'CourseOptionDescriptor';
  canBeDeleted: Scalars['Boolean'];
  canBeUpdated: Scalars['Boolean'];
  description?: Maybe<Scalars['String']>;
  expenseDescriptor: ExpenseDescriptor;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CoursePart = Named & Node & Timestamped & {
  __typename?: 'CoursePart';
  createdAt: Scalars['DateTime'];
  endDate: Scalars['Date'];
  events: Array<CourseEvent>;
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
};

/** A record of a person's participation in a course. */
export type CourseParticipationCertificate = Node & ProcessResource & {
  __typename?: 'CourseParticipationCertificate';
  /**
   * The course admin file this certificate is connected to, or `null` if
   * has been created manually.
   *
   * A certificate connected to an admin file cannot be updated or deleted.
   */
  adminFile?: Maybe<CourseAdminFile>;
  /**
   * The completion of the course in percent.
   *
   * If `courseSummary.duration` exists, completion relates to this amount of time.
   */
  completion?: Maybe<Scalars['Float']>;
  courseSummary: CourseParticipationCourseSummary;
  /** Whether a file exists which documents the participation. */
  hasDocument: Scalars['Boolean'];
  id: Scalars['ID'];
  /** The person this certificate belongs to and whose participation is certified by it. */
  person: Person;
  /** The associated data processing process. */
  process: DataProcessingProcess;
};

/** Summary information about a course which is included in a `CourseParticipationCertificate`. */
export type CourseParticipationCourseSummary = Named & {
  __typename?: 'CourseParticipationCourseSummary';
  /** The amount of time that is required of participants to complete the course. */
  duration?: Maybe<Scalars['Duration']>;
  /** The level of the course. */
  level: CourseLevel;
  /** The name of the course. */
  name: Scalars['String'];
  /** The part of the course. */
  part: Scalars['String'];
  /** The year in which the course was held. */
  year: Scalars['Int'];
};

export type CourseParticipationCourseSummaryInput = {
  duration?: InputMaybe<Scalars['Duration']>;
  level: CourseLevel;
  name: Scalars['String'];
  part: Scalars['String'];
  year: Scalars['Int'];
};

export type CreateAdminAppUserInput = {
  personId: Scalars['ID'];
  roles?: InputMaybe<Array<UserRole>>;
};

export type CreateCourseAdminFileExpenseReceiptInput = {
  adminFileId: Scalars['ID'];
};

export type CreateCourseAdminFileInput = {
  groupId: Scalars['ID'];
  personId: Scalars['ID'];
};

export type CreateCourseAdminGroupInput = {
  courseId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCourseEventInput = {
  coursePartId: Scalars['ID'];
  endDate: Scalars['DateTime'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type CreateCourseInput = {
  level: CourseLevel;
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateCourseOptionBookingInput = {
  adminFileId: Scalars['ID'];
  descriptorId: Scalars['ID'];
};

export type CreateCourseOptionBookingPaymentInput = {
  bookingId: Scalars['ID'];
  payment: PaymentInput;
};

export type CreateCourseOptionDescriptorInput = {
  description?: InputMaybe<Scalars['String']>;
  expenseAmount: MoneyInput;
  groupId: Scalars['ID'];
  name: Scalars['String'];
};

export type CreateCoursePartInput = {
  courseId: Scalars['ID'];
  endDate: Scalars['Date'];
  name: Scalars['String'];
  startDate: Scalars['Date'];
};

export type CreateCourseParticipationCertificateInput = {
  completion?: InputMaybe<Scalars['Float']>;
  courseSummary: CourseParticipationCourseSummaryInput;
  personId: Scalars['ID'];
};

export type CreateDataProcessingAgreementChangeEventInput = {
  changes?: InputMaybe<Array<DataProcessingAgreementChangeInput>>;
  date: Scalars['Date'];
  personId: Scalars['ID'];
};

export type CreateDocumentTagInput = {
  name: Scalars['String'];
  organizationId: Scalars['ID'];
};

export type CreateMemberPortalUserInput = {
  materialAccessCourseLevels?: InputMaybe<Array<CourseLevel>>;
  personId: Scalars['ID'];
};

export type CreateOrganizationInput = {
  address: PostalAddressInput;
  membershipRequiresContribution?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  officialName: Scalars['String'];
  receiptsFooter?: InputMaybe<Scalars['String']>;
};

export type CreateOrganizationMembershipInput = {
  /** The id of the organization to which the new membership belongs. */
  organizationId: Scalars['ID'];
  /** The id of the person which is the new member of the organization. */
  personId: Scalars['ID'];
};

export type CreatePersonInput = {
  email?: InputMaybe<PersonEmailInput>;
  homeAddress?: InputMaybe<PostalAddressInput>;
  name?: InputMaybe<PersonNameInput>;
  phone?: InputMaybe<PersonPhoneInput>;
};

export type DataProcessingActivity = Node & {
  __typename?: 'DataProcessingActivity';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  requirements: Array<DataProcessingRequirement>;
};

export type DataProcessingAgreementChange = {
  __typename?: 'DataProcessingAgreementChange';
  activity: DataProcessingActivity;
  permissionStatus: DataProcessingAgreementPermissionStatus;
};

export type DataProcessingAgreementChangeEvent = Node & {
  __typename?: 'DataProcessingAgreementChangeEvent';
  changes: Array<DataProcessingAgreementChange>;
  date: Scalars['Date'];
  hasDocumentation: Scalars['Boolean'];
  id: Scalars['ID'];
  /**
   * Whether this event is managed by the system.
   *
   * Managed events are not mutable by users.
   */
  isManaged: Scalars['Boolean'];
};

export type DataProcessingAgreementChangeInput = {
  activityId: Scalars['ID'];
  permissionStatus: DataProcessingAgreementPermissionStatus;
};

export enum DataProcessingAgreementPermissionStatus {
  Granted = 'Granted',
  Revoked = 'Revoked'
}

export type DataProcessingProcess = Node & {
  __typename?: 'DataProcessingProcess';
  activity: DataProcessingActivity;
  id: Scalars['ID'];
  /**
   * Whether the `Person` this process belongs to has given permission for the processing of their
   * data in this process.
   */
  permissionExists?: Maybe<Scalars['Boolean']>;
  resource?: Maybe<ProcessResource>;
  retentionConfig?: Maybe<ProcessRetentionConfig>;
  retentionEnd?: Maybe<Scalars['DateTime']>;
  retentionStart?: Maybe<Scalars['DateTime']>;
  start: Scalars['DateTime'];
  state: ProcessState;
};

export type DataProcessingProcessConnection = Connection & {
  __typename?: 'DataProcessingProcessConnection';
  edges: Array<DataProcessingProcessEdge>;
  pageInfo: PageInfo;
};

export type DataProcessingProcessEdge = Edge & {
  __typename?: 'DataProcessingProcessEdge';
  cursor: Scalars['String'];
  node: DataProcessingProcess;
};

export type DataProcessingRequirement = {
  __typename?: 'DataProcessingRequirement';
  preventDeletion: Scalars['Boolean'];
  required: Scalars['Boolean'];
  scope: PersonScope;
};

export type DeleteAdminAppUserInput = {
  id: Scalars['ID'];
};

export type DeleteCourseAdminFileExpenseReceiptInput = {
  id: Scalars['ID'];
};

export type DeleteCourseAdminFileInput = {
  id: Scalars['ID'];
};

export type DeleteCourseAdminGroupInput = {
  id: Scalars['ID'];
};

export type DeleteCourseEventInput = {
  coursePartId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteCourseInput = {
  id: Scalars['ID'];
};

export type DeleteCourseOptionBookingInput = {
  id: Scalars['ID'];
};

export type DeleteCourseOptionBookingPaymentInput = {
  bookingId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteCourseOptionDescriptorInput = {
  id: Scalars['ID'];
};

export type DeleteCoursePartInput = {
  id: Scalars['ID'];
};

export type DeleteCourseParticipationCertificateInput = {
  id: Scalars['ID'];
};

export type DeleteDataProcessingAgreementChangeEventInput = {
  id: Scalars['ID'];
};

export type DeleteDocumentInput = {
  id: Scalars['ID'];
};

export type DeleteDocumentTagInput = {
  id: Scalars['ID'];
};

export type DeleteMemberPortalUserInput = {
  id: Scalars['ID'];
};

export type DeleteOrganizationInput = {
  id: Scalars['ID'];
};

export type DeleteOrganizationMembershipInput = {
  /** The id of the membership to delete. */
  id: Scalars['ID'];
};

export type DeletePersonInput = {
  id: Scalars['ID'];
};

/** A thing which has restrictions on when it can be deleted. */
export type DeleteRestricted = {
  /** Whether or not this thing can be deleted at the moment. */
  canBeDeleted: Scalars['Boolean'];
};

export type Document = Named & Node & Timestamped & {
  __typename?: 'Document';
  /** The MIME type of the content of this `Document`. */
  contentType: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  /** The file name of this `Document`. */
  name: Scalars['String'];
  /** Size of this `Document` in bytes. */
  size: Scalars['Int'];
  /** The `DocumentTag`s that have been assigned to this `Document` */
  tags: Array<DocumentTag>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  edges: Array<DocumentEdge>;
  pageInfo: PageInfo;
};

export type DocumentEdge = Edge & {
  __typename?: 'DocumentEdge';
  cursor: Scalars['String'];
  node: Document;
};

/** The properties by which `Document`s can be ordered. */
export enum DocumentOrderBy {
  CreatedAt = 'CreatedAt',
  Name = 'Name'
}

/** A tag that is used to organize `Document`s. */
export type DocumentTag = Named & Node & Timestamped & {
  __typename?: 'DocumentTag';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  modifiedAt: Scalars['DateTime'];
  /** The name of this `DocumentTag`. */
  name: Scalars['String'];
};

/** An edge contains a `Node` inside a `Connection`. */
export type Edge = {
  /** The curser of `node` in the `Connection`. */
  cursor: Scalars['String'];
  /** This edges `Node`. */
  node: Node;
};

export type Expense = Node & {
  __typename?: 'Expense';
  balance: Money;
  descriptor: ExpenseDescriptor;
  discount: Money;
  due: Money;
  hasReceipt: Scalars['Boolean'];
  hasReceiptContributions: Scalars['Boolean'];
  id: Scalars['ID'];
  nominal: Money;
  payed: Money;
  payments: Array<Payment>;
};

export type ExpenseDescriptor = Named & Node & {
  __typename?: 'ExpenseDescriptor';
  amount: Money;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ExpenseReceipt = Node & {
  __typename?: 'ExpenseReceipt';
  databaseId: Scalars['ID'];
  generatedAt: Scalars['DateTime'];
  id: Scalars['ID'];
  note: Scalars['String'];
  rescinded: Scalars['Boolean'];
};

/** A `MemberPortalUser` allows a `Perons` to access the member portal. */
export type MemberPortalUser = Node & ProcessResource & Timestamped & {
  __typename?: 'MemberPortalUser';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The `CourseLevel`s for which this user has access to the course materials. */
  materialAccessCourseLevels: Array<CourseLevel>;
  modifiedAt: Scalars['DateTime'];
  /** The `Person` this `AdminAppUser` belongs to. */
  person: Person;
  process: DataProcessingProcess;
};

export type Money = {
  __typename?: 'Money';
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type MoneyInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Creates an `AdminAppUser`. */
  createAdminAppUser: AdminAppUser;
  createCourse: Course;
  createCourseAdminFile: CourseAdminFile;
  createCourseAdminFileExpenseReceipt: ExpenseReceipt;
  createCourseAdminGroup: CourseAdminGroup;
  createCourseEvent: CourseEvent;
  createCourseOptionBooking: CourseOptionBooking;
  createCourseOptionBookingPayment: Payment;
  createCourseOptionDescriptor: CourseOptionDescriptor;
  createCoursePart: CoursePart;
  createCourseParticipationCertificate: CourseParticipationCertificate;
  createDataProcessingAgreementChangeEvent?: Maybe<DataProcessingAgreementChangeEvent>;
  /**
   * Creates a `DocumentTag`.
   *
   * Requires the Admin role.
   */
  createDocumentTag: DocumentTag;
  /** Creates a `MemberPortalUser`. */
  createMemberPortalUser: MemberPortalUser;
  createOrganization: Organization;
  /** Creates a new membership and returns it. */
  createOrganizationMembership: OrganizationMembership;
  createPerson: Person;
  /** Deletes an `AdminAppUser`. */
  deleteAdminAppUser: Scalars['Boolean'];
  deleteCourse: Scalars['Boolean'];
  deleteCourseAdminFile: Scalars['Boolean'];
  deleteCourseAdminFileExpenseReceipt: Scalars['Boolean'];
  deleteCourseAdminGroup: Scalars['Boolean'];
  deleteCourseEvent: Scalars['Boolean'];
  deleteCourseOptionBooking: Scalars['Boolean'];
  deleteCourseOptionBookingPayment: Scalars['Boolean'];
  deleteCourseOptionDescriptor: Scalars['Boolean'];
  deleteCoursePart: Scalars['Boolean'];
  deleteCourseParticipationCertificate: Scalars['Boolean'];
  deleteDataProcessingAgreementChangeEvent?: Maybe<Scalars['Boolean']>;
  /**
   * Deletes a `Document`.
   *
   * Requires the Admin role.
   */
  deleteDocument: Scalars['Boolean'];
  /**
   * Deletes a `DocumentTag`.
   *
   * Requires the Admin role.
   */
  deleteDocumentTag: Scalars['Boolean'];
  /** Updates a `MemberPortalUser`. */
  deleteMemberPortalUser: Scalars['Boolean'];
  deleteOrganization: Scalars['Boolean'];
  /** Deletes an existing membership and returns true. */
  deleteOrganizationMembership: Scalars['Boolean'];
  deletePerson: Scalars['Boolean'];
  /** Signs up a `Person` for the newsletter. */
  signUpForNewsletter: Scalars['Boolean'];
  /** Signs up a new `MemberPortalUser`. */
  signUpMemberPortalUser: MemberPortalUser;
  /** Updates an `AdminAppUser`. */
  updateAdminAppUser: AdminAppUser;
  updateCourse: Course;
  updateCourseAdminFile: CourseAdminFile;
  updateCourseAdminFileExpenseReceipt: ExpenseReceipt;
  updateCourseAdminGroup: CourseAdminGroup;
  updateCourseEvent: CourseEvent;
  updateCourseOptionBooking: CourseOptionBooking;
  updateCourseOptionDescriptor: CourseOptionDescriptor;
  updateCoursePart: CoursePart;
  updateCourseParticipationCertificate: CourseParticipationCertificate;
  updateDataProcessingAgreementChangeEvent?: Maybe<DataProcessingAgreementChangeEvent>;
  /** Updates a `Document`. */
  updateDocument: Document;
  /**
   * Updates a `DocumentTag`.
   *
   * Requires the Admin role.
   */
  updateDocumentTag: DocumentTag;
  /** Updates a `MemberPortalUser`. */
  updateMemberPortalUser: MemberPortalUser;
  updateOrganization: Organization;
  /** Updates an existing membership and returns it. */
  updateOrganizationMembership: OrganizationMembership;
  updatePerson: Person;
  /** Updates an `UserAccount`. */
  updateUserAccount: UserAccount;
};


export type MutationCreateAdminAppUserArgs = {
  input: CreateAdminAppUserInput;
};


export type MutationCreateCourseArgs = {
  input: CreateCourseInput;
};


export type MutationCreateCourseAdminFileArgs = {
  input: CreateCourseAdminFileInput;
};


export type MutationCreateCourseAdminFileExpenseReceiptArgs = {
  input: CreateCourseAdminFileExpenseReceiptInput;
};


export type MutationCreateCourseAdminGroupArgs = {
  input: CreateCourseAdminGroupInput;
};


export type MutationCreateCourseEventArgs = {
  input: CreateCourseEventInput;
};


export type MutationCreateCourseOptionBookingArgs = {
  input: CreateCourseOptionBookingInput;
};


export type MutationCreateCourseOptionBookingPaymentArgs = {
  input: CreateCourseOptionBookingPaymentInput;
};


export type MutationCreateCourseOptionDescriptorArgs = {
  input: CreateCourseOptionDescriptorInput;
};


export type MutationCreateCoursePartArgs = {
  input: CreateCoursePartInput;
};


export type MutationCreateCourseParticipationCertificateArgs = {
  input?: InputMaybe<CreateCourseParticipationCertificateInput>;
};


export type MutationCreateDataProcessingAgreementChangeEventArgs = {
  input: CreateDataProcessingAgreementChangeEventInput;
};


export type MutationCreateDocumentTagArgs = {
  input: CreateDocumentTagInput;
};


export type MutationCreateMemberPortalUserArgs = {
  input: CreateMemberPortalUserInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationMembershipArgs = {
  input: CreateOrganizationMembershipInput;
};


export type MutationCreatePersonArgs = {
  input?: InputMaybe<CreatePersonInput>;
};


export type MutationDeleteAdminAppUserArgs = {
  input: DeleteAdminAppUserInput;
};


export type MutationDeleteCourseArgs = {
  input: DeleteCourseInput;
};


export type MutationDeleteCourseAdminFileArgs = {
  input: DeleteCourseAdminFileInput;
};


export type MutationDeleteCourseAdminFileExpenseReceiptArgs = {
  input: DeleteCourseAdminFileExpenseReceiptInput;
};


export type MutationDeleteCourseAdminGroupArgs = {
  input: DeleteCourseAdminGroupInput;
};


export type MutationDeleteCourseEventArgs = {
  input: DeleteCourseEventInput;
};


export type MutationDeleteCourseOptionBookingArgs = {
  input: DeleteCourseOptionBookingInput;
};


export type MutationDeleteCourseOptionBookingPaymentArgs = {
  input: DeleteCourseOptionBookingPaymentInput;
};


export type MutationDeleteCourseOptionDescriptorArgs = {
  input: DeleteCourseOptionDescriptorInput;
};


export type MutationDeleteCoursePartArgs = {
  input: DeleteCoursePartInput;
};


export type MutationDeleteCourseParticipationCertificateArgs = {
  input?: InputMaybe<DeleteCourseParticipationCertificateInput>;
};


export type MutationDeleteDataProcessingAgreementChangeEventArgs = {
  input: DeleteDataProcessingAgreementChangeEventInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteDocumentInput;
};


export type MutationDeleteDocumentTagArgs = {
  input: DeleteDocumentTagInput;
};


export type MutationDeleteMemberPortalUserArgs = {
  input: DeleteMemberPortalUserInput;
};


export type MutationDeleteOrganizationArgs = {
  input: DeleteOrganizationInput;
};


export type MutationDeleteOrganizationMembershipArgs = {
  input: DeleteOrganizationMembershipInput;
};


export type MutationDeletePersonArgs = {
  input: DeletePersonInput;
};


export type MutationSignUpForNewsletterArgs = {
  input: SignUpForNewsletterInput;
};


export type MutationSignUpMemberPortalUserArgs = {
  input: SignUpMemberPortalUserInput;
};


export type MutationUpdateAdminAppUserArgs = {
  input: UpdateAdminAppUserInput;
};


export type MutationUpdateCourseArgs = {
  input: UpdateCourseInput;
};


export type MutationUpdateCourseAdminFileArgs = {
  input: UpdateCourseAdminFileInput;
};


export type MutationUpdateCourseAdminFileExpenseReceiptArgs = {
  input: UpdateCourseAdminFileExpenseReceiptInput;
};


export type MutationUpdateCourseAdminGroupArgs = {
  input: UpdateCourseAdminGroupInput;
};


export type MutationUpdateCourseEventArgs = {
  input: UpdateCourseEventInput;
};


export type MutationUpdateCourseOptionBookingArgs = {
  input: UpdateCourseOptionBookingInput;
};


export type MutationUpdateCourseOptionDescriptorArgs = {
  input: UpdateCourseOptionDescriptorInput;
};


export type MutationUpdateCoursePartArgs = {
  input: UpdateCoursePartInput;
};


export type MutationUpdateCourseParticipationCertificateArgs = {
  input?: InputMaybe<UpdateCourseParticipationCertificateInput>;
};


export type MutationUpdateDataProcessingAgreementChangeEventArgs = {
  input: UpdateDataProcessingAgreementChangeEventInput;
};


export type MutationUpdateDocumentArgs = {
  input: UpdateDocumentInput;
};


export type MutationUpdateDocumentTagArgs = {
  input: UpdateDocumentTagInput;
};


export type MutationUpdateMemberPortalUserArgs = {
  input: UpdateMemberPortalUserInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationMembershipArgs = {
  input: UpdateOrganizationMembershipInput;
};


export type MutationUpdatePersonArgs = {
  input: UpdatePersonInput;
};


export type MutationUpdateUserAccountArgs = {
  input: UpdateUserAccountInput;
};

/** A thing which has a name. */
export type Named = {
  /** The name of this thing. */
  name: Scalars['String'];
};

/**
 * A thing which can be fetched from the `Query.node` field.
 *
 * This has the advantage that, all things which implement this interface can be fetched through a single field, instead
 * of requiring their own individual field in `Query`.
 */
export type Node = {
  /** The id of this `Node`. */
  id: Scalars['ID'];
};

/** The direction of an ordered list. */
export enum OrderDirection {
  Ascending = 'Ascending',
  Descending = 'Descending'
}

export type Organization = Named & Node & Timestamped & {
  __typename?: 'Organization';
  address: PostalAddress;
  courses: CourseConnection;
  createdAt: Scalars['DateTime'];
  /** All the `DocumentTag`s that belong to this `Organization`. */
  documentTags: Array<DocumentTag>;
  /**
   * All the `Document`s that belong to this `Organization`.
   *
   * If `tags` is specified, only `Document`s with all the specified `DocumentTag`s are included.
   *
   * The order of the returned connection can be controlled through `orderBy` and `orderDirection`.
   */
  documents: DocumentConnection;
  id: Scalars['ID'];
  /** Whether members in this organization are required to make reoccurring contributions. */
  membershipRequiresContribution: Scalars['Boolean'];
  memberships: OrganizationMembershipConnection;
  modifiedAt: Scalars['DateTime'];
  name: Scalars['String'];
  officialName: Scalars['String'];
  receiptsFooter?: Maybe<Scalars['String']>;
};


export type OrganizationCoursesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type OrganizationDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  orderBy?: DocumentOrderBy;
  orderDirection?: OrderDirection;
  tags?: InputMaybe<Array<Scalars['ID']>>;
};


export type OrganizationMembershipsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The membership of a `Person` in an `Organization`. */
export type OrganizationMembership = Node & ProcessResource & Timestamped & {
  __typename?: 'OrganizationMembership';
  /** The date of the creation of this membership. */
  createdAt: Scalars['DateTime'];
  /** The end date of this membership. */
  endDate?: Maybe<Scalars['Date']>;
  /** Whether or not this membership has an attached file. */
  hasAttachment: Scalars['Boolean'];
  /** The id of this membership. */
  id: Scalars['ID'];
  /** Whether or not this membership is active. */
  isActive: Scalars['Boolean'];
  /** The date of the last modification of this membership. */
  modifiedAt: Scalars['DateTime'];
  /** The organization to which this membership belongs. */
  organization: Organization;
  /** The person which is the member of the organization. */
  person: Person;
  process: DataProcessingProcess;
  /** The start date of this membership. */
  startDate: Scalars['Date'];
};

export type OrganizationMembershipConnection = Connection & {
  __typename?: 'OrganizationMembershipConnection';
  edges: Array<OrganizationMembershipEdge>;
  pageInfo: PageInfo;
};

export type OrganizationMembershipEdge = Edge & {
  __typename?: 'OrganizationMembershipEdge';
  cursor: Scalars['String'];
  node: OrganizationMembership;
};

/** Information about a page, which is part of a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** The cursor to the last `Node` in the connection. */
  endCursor: Scalars['String'];
  /** Whether there is a next page in the `Connection`. */
  hasNextPage: Scalars['Boolean'];
  /** Whether there is a previous page in the `Connection`. */
  hasPreviousPage: Scalars['Boolean'];
  /** The number of the current page. */
  page?: Maybe<Scalars['Int']>;
  /** The size of the current page. */
  size: Scalars['Int'];
  /** The cursor to the first `Node` in the connection. */
  startCursor: Scalars['String'];
  /** The total number of edges in the connection. */
  totalEdges?: Maybe<Scalars['Int']>;
  /** The total number of pages in the connection. */
  totalPages?: Maybe<Scalars['Int']>;
};

export type Payment = Node & {
  __typename?: 'Payment';
  amount: Money;
  id: Scalars['ID'];
  method: PaymentMethod;
  receivedAt: Scalars['DateTime'];
};

export type PaymentInput = {
  amount?: InputMaybe<MoneyInput>;
  id?: InputMaybe<Scalars['ID']>;
  method?: InputMaybe<PaymentMethod>;
  receivedAt?: InputMaybe<Scalars['DateTime']>;
};

export enum PaymentMethod {
  BankTransfer = 'BankTransfer',
  Cash = 'Cash'
}

export type Person = DeleteRestricted & Node & Timestamped & {
  __typename?: 'Person';
  /** The `AdminAppUser` of this `Person`, if it exists. */
  adminAppUser?: Maybe<AdminAppUser>;
  canBeDeleted: Scalars['Boolean'];
  courseParticipationCertificates: Array<CourseParticipationCertificate>;
  createdAt: Scalars['DateTime'];
  dataProcessingAgreementChangeEvents: Array<DataProcessingAgreementChangeEvent>;
  dataProcessingProcesses: DataProcessingProcessConnection;
  databaseId: Scalars['ID'];
  displayName?: Maybe<Scalars['String']>;
  email?: Maybe<PersonEmail>;
  homeAddress?: Maybe<PersonAddress>;
  id: Scalars['ID'];
  /** The `MemberPortalUser` of this `Person`, if it exists. */
  memberPortalUser?: Maybe<MemberPortalUser>;
  modifiedAt: Scalars['DateTime'];
  name?: Maybe<PersonName>;
  organizationMemberships: Array<OrganizationMembership>;
  phone?: Maybe<PersonPhone>;
  /** The `UserAccount` of this `Person`, if it exists. */
  userAccount?: Maybe<UserAccount>;
};


export type PersonDataProcessingProcessesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

export type PersonAddress = DeleteRestricted & PersonScopeData & {
  __typename?: 'PersonAddress';
  address: PostalAddress;
  canBeDeleted: Scalars['Boolean'];
};

export type PersonConnection = Connection & {
  __typename?: 'PersonConnection';
  edges: Array<PersonEdge>;
  pageInfo: PageInfo;
};

export type PersonEdge = Edge & {
  __typename?: 'PersonEdge';
  cursor: Scalars['String'];
  node: Person;
};

export type PersonEmail = DeleteRestricted & PersonScopeData & {
  __typename?: 'PersonEmail';
  canBeDeleted: Scalars['Boolean'];
  emailAddress: Scalars['String'];
};

export type PersonEmailInput = {
  emailAddress: Scalars['String'];
};

/** Filters to limit which `Person`s are returned. */
export type PersonFilters = {
  /** `Person` has to have a set of `UserRole`s. */
  hasAdminAppRole?: InputMaybe<Array<UserRole>>;
  /** `Person` has to have currently agreed to all the given `DataProcessingActivity`. */
  hasAgreedToDataProcessingActivities?: InputMaybe<Array<Scalars['ID']>>;
  /** `Person` has to have at least one `CourseParticipationCertificate` for each of the given levels. */
  hasCourseParticipationCertificatesWithLevels?: InputMaybe<Array<CourseLevel>>;
  /** `Person` has one or more `DataProcessingProcess`es where `permissionExists` is `false`. */
  hasDataProcessingProcessWithoutPermission?: InputMaybe<Scalars['Boolean']>;
  /** `Person` has at least some data which can be deleted. */
  hasDeletableData?: InputMaybe<Scalars['Boolean']>;
  /** `Person` has to have access to the materials of a set of `CourseLevel`s. */
  hasMaterialAccessCourseLevels?: InputMaybe<Array<CourseLevel>>;
  /** `Person` has to have at least one `CourseAdminFile` for which no `CourseParticipationCertificate` has been saved. */
  hasUnsavedCourseParticipationCertificate?: InputMaybe<Scalars['Boolean']>;
  /** `Person` has to be an `AdminAppUser`. */
  isAdminAppUser?: InputMaybe<Scalars['Boolean']>;
  /** `Person` can be deleted. */
  isDeletable?: InputMaybe<Scalars['Boolean']>;
  /** `Person` is a member of one or all of the given Organizations. */
  isMemberOfOrganizations?: InputMaybe<Array<Scalars['ID']>>;
  /** `Person` has to be a `MemberPortalUser`. */
  isMemberPortalUser?: InputMaybe<Scalars['Boolean']>;
  /** How to combine facets when more than one is given. Defaults to `And`. */
  operator?: InputMaybe<QueryOperator>;
};

export type PersonName = DeleteRestricted & PersonScopeData & {
  __typename?: 'PersonName';
  canBeDeleted: Scalars['Boolean'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
};

export type PersonNameInput = {
  familyName: Scalars['String'];
  givenName: Scalars['String'];
};

export type PersonPhone = DeleteRestricted & PersonScopeData & {
  __typename?: 'PersonPhone';
  canBeDeleted: Scalars['Boolean'];
  primaryNumber: Scalars['String'];
  secondaryNumber?: Maybe<Scalars['String']>;
};

export type PersonPhoneInput = {
  primaryNumber: Scalars['String'];
  secondaryNumber?: InputMaybe<Scalars['String']>;
};

export enum PersonScope {
  Email = 'Email',
  HomeAddress = 'HomeAddress',
  Name = 'Name',
  Phone = 'Phone'
}

export type PersonScopeData = {
  canBeDeleted: Scalars['Boolean'];
};

/** A postal address. */
export type PostalAddress = {
  __typename?: 'PostalAddress';
  /** The first line of this address. */
  addressLine1: Scalars['String'];
  /** The second line of this address. */
  addressLine2?: Maybe<Scalars['String']>;
  /** The area of this address. */
  area?: Maybe<Scalars['String']>;
  /** The city of this address. */
  city: Scalars['String'];
  /** The country of this address. */
  country: Scalars['String'];
  /** The postal code of this address. */
  postalCode: Scalars['String'];
};

/** Input for `PostalAddress`. */
export type PostalAddressInput = {
  /** The first line of this address. */
  addressLine1: Scalars['String'];
  /** The second line of this address. */
  addressLine2?: InputMaybe<Scalars['String']>;
  /** The area of this address. */
  area?: InputMaybe<Scalars['String']>;
  /** The city of this address. */
  city: Scalars['String'];
  /** The country of this address. */
  country: Scalars['String'];
  /** The postal code of this address. */
  postalCode: Scalars['String'];
};

/** A resource which represents a `DataProcessingProcess`. */
export type ProcessResource = {
  /** The id of this resource. */
  id: Scalars['ID'];
  /** The `DataProcessingProcess` this resource is representing. */
  process: DataProcessingProcess;
};

export type ProcessRetentionConfig = {
  __typename?: 'ProcessRetentionConfig';
  duration: Scalars['Int'];
  startAdjuster: RetentionStartAdjuster;
  unit: TimeUnit;
};

export enum ProcessState {
  Open = 'Open',
  Passive = 'Passive',
  Retention = 'Retention',
  Terminated = 'Terminated'
}

export type Query = {
  __typename?: 'Query';
  /**
   * Returns a connection of `AuditEvent`s, supporting filtering by `time`, `actorId` and
   * `resourceId` of the event.
   */
  auditEvents: AuditEventConnection;
  dataProcessingActivities: Array<DataProcessingActivity>;
  /** Returns the `Node` identified by `id`. */
  node: Node;
  organizations: Array<Organization>;
  personSearch: Array<Person>;
  persons: PersonConnection;
  /** The `UserAccount` of the currently authenticated user, if it exists. */
  viewerUserAccount?: Maybe<UserAccount>;
};


export type QueryAuditEventsArgs = {
  after?: InputMaybe<Scalars['String']>;
  afterTime?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  beforeTime?: InputMaybe<Scalars['DateTime']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<AuditResourceMatchers>;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
};


export type QueryPersonSearchArgs = {
  query: Scalars['String'];
};


export type QueryPersonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<PersonFilters>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The operation to use when a query has multiple facets. */
export enum QueryOperator {
  /** An item must match every facet. */
  And = 'And',
  /** An item must match at least one facet. */
  Or = 'Or'
}

export enum RetentionStartAdjuster {
  FirstDayOfNextYear = 'FirstDayOfNextYear',
  Immediately = 'Immediately'
}

/** Input for `signUpForNewsletter`. */
export type SignUpForNewsletterInput = {
  /** The email address of the `Person` to sign up. */
  email: PersonEmailInput;
  /** The name of the person to sign up. */
  name: PersonNameInput;
};

export type SignUpMemberPortalUserInput = {
  name: PersonNameInput;
};

/** A date period unit. */
export enum TimeUnit {
  /** Unit that represents the concept of a year. */
  Years = 'Years'
}

/** A thing which includes timestamps of creation and modification. */
export type Timestamped = {
  /** The date of the creation of this thing. */
  createdAt: Scalars['DateTime'];
  /** The date of the last modification of this thing. */
  modifiedAt: Scalars['DateTime'];
};

export type UpdateAdminAppUserInput = {
  id: Scalars['ID'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  roles?: InputMaybe<Array<UserRole>>;
};

export type UpdateCourseAdminFileExpenseReceiptInput = {
  id: Scalars['ID'];
  note?: InputMaybe<Scalars['String']>;
  rescinded?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCourseAdminFileInput = {
  eventAttendances?: InputMaybe<Array<CourseEventAttendanceInput>>;
  id: Scalars['ID'];
  isArchived?: InputMaybe<Scalars['Boolean']>;
  isRescinded?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCourseAdminGroupInput = {
  id: Scalars['ID'];
  /**
   * Whether this group is archived.
   *
   * See:
   *
   * - `CourseAdminGroup.isArchived`
   */
  isArchived?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  partIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateCourseEventInput = {
  coursePartId: Scalars['ID'];
  endDate?: InputMaybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateCourseInput = {
  id: Scalars['ID'];
  level?: InputMaybe<CourseLevel>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCourseOptionBookingInput = {
  discount?: InputMaybe<MoneyInput>;
  id: Scalars['ID'];
};

export type UpdateCourseOptionDescriptorInput = {
  description?: InputMaybe<Scalars['String']>;
  expenseAmount?: InputMaybe<MoneyInput>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCoursePartInput = {
  endDate?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['Date']>;
};

export type UpdateCourseParticipationCertificateInput = {
  completion?: InputMaybe<Scalars['Float']>;
  courseSummary: CourseParticipationCourseSummaryInput;
  id: Scalars['ID'];
};

export type UpdateDataProcessingAgreementChangeEventInput = {
  changes?: InputMaybe<Array<DataProcessingAgreementChangeInput>>;
  date?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
};

export type UpdateDocumentInput = {
  id: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['ID']>>;
};

export type UpdateDocumentTagInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateMemberPortalUserInput = {
  id: Scalars['ID'];
  materialAccessCourseLevels?: InputMaybe<Array<CourseLevel>>;
};

export type UpdateOrganizationInput = {
  address?: InputMaybe<PostalAddressInput>;
  id: Scalars['ID'];
  membershipRequiresContribution?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  officialName?: InputMaybe<Scalars['String']>;
  receiptsFooter?: InputMaybe<Scalars['String']>;
};

export type UpdateOrganizationMembershipInput = {
  /** The new start date of the membership. Setting this date ends the membership. */
  endDate?: InputMaybe<Scalars['Date']>;
  /** The id of the membership to update. */
  id: Scalars['ID'];
  /** The new start date of the membership. */
  startDate?: InputMaybe<Scalars['Date']>;
};

export type UpdatePersonInput = {
  email?: InputMaybe<PersonEmailInput>;
  homeAddress?: InputMaybe<PostalAddressInput>;
  id: Scalars['ID'];
  name?: InputMaybe<PersonNameInput>;
  phone?: InputMaybe<PersonPhoneInput>;
};

/** A thing which has restrictions on when it can be update. */
export type UpdateRestricted = {
  /** Whether or not this thing can be updated at the moment. */
  canBeUpdated: Scalars['Boolean'];
};

export type UpdateUserAccountInput = {
  id: Scalars['ID'];
  mfa?: InputMaybe<Scalars['Boolean']>;
};

export type UserAccount = Node & {
  __typename?: 'UserAccount';
  id: Scalars['ID'];
  /** Whether multi factor authentication is enabled and required for the user signs in. */
  mfa: Scalars['Boolean'];
  /** The `Person` this `UserAccount` belongs to. */
  person: Person;
};

/**
 * A role, which can be assigned to an `AdminAppUser`. Roles govern the access rights of a
 * `AdminAppUser`.
 */
export enum UserRole {
  /** Grants an `AdminAppUser` access to the complete system. */
  Admin = 'Admin',
  /** Grants an `AdminAppUser` access to most of the system. */
  Staff = 'Staff'
}

export type AuditEventsViewerQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<AuditResourceMatchers>;
}>;


export type AuditEventsViewerQuery = { __typename?: 'Query', auditEvents: { __typename?: 'AuditEventConnection', events: Array<{ __typename?: 'AuditEventEdge', node: { __typename?: 'AuditEvent', id: string, time: any, type: AuditEventType, details?: any | null | undefined, resources: Array<{ __typename?: 'AuditResource', classifier: AuditResourceClassifier, id: string, resourceId: string, resourceType: string, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'AuditEvent', id: string } | { __typename: 'AuditResource', id: string } | { __typename: 'Course', name: string, id: string } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } | { __typename: 'CourseEvent', name: string, id: string } | { __typename: 'CourseEventAttendance', id: string } | { __typename: 'CourseOptionBooking', id: string } | { __typename: 'CourseOptionDescriptor', name: string, id: string } | { __typename: 'CoursePart', name: string, id: string } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'DataProcessingActivity', id: string } | { __typename: 'DataProcessingAgreementChangeEvent', id: string } | { __typename: 'DataProcessingProcess', id: string } | { __typename: 'Document', id: string } | { __typename: 'DocumentTag', id: string } | { __typename: 'Expense', id: string } | { __typename: 'ExpenseDescriptor', id: string } | { __typename: 'ExpenseReceipt', id: string } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'Organization', name: string, id: string } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | { __typename: 'Payment', id: string } | { __typename: 'Person', displayName?: string | null | undefined, id: string } | { __typename: 'UserAccount', id: string } | null | undefined } | null | undefined> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'AuditEventEdge', cursor: string }> } };

export type AuditEventRowFragment = { __typename?: 'AuditEvent', id: string, time: any, type: AuditEventType, details?: any | null | undefined, resources: Array<{ __typename?: 'AuditResource', classifier: AuditResourceClassifier, id: string, resourceId: string, resourceType: string, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'AuditEvent', id: string } | { __typename: 'AuditResource', id: string } | { __typename: 'Course', name: string, id: string } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } | { __typename: 'CourseEvent', name: string, id: string } | { __typename: 'CourseEventAttendance', id: string } | { __typename: 'CourseOptionBooking', id: string } | { __typename: 'CourseOptionDescriptor', name: string, id: string } | { __typename: 'CoursePart', name: string, id: string } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'DataProcessingActivity', id: string } | { __typename: 'DataProcessingAgreementChangeEvent', id: string } | { __typename: 'DataProcessingProcess', id: string } | { __typename: 'Document', id: string } | { __typename: 'DocumentTag', id: string } | { __typename: 'Expense', id: string } | { __typename: 'ExpenseDescriptor', id: string } | { __typename: 'ExpenseReceipt', id: string } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'Organization', name: string, id: string } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | { __typename: 'Payment', id: string } | { __typename: 'Person', displayName?: string | null | undefined, id: string } | { __typename: 'UserAccount', id: string } | null | undefined } | null | undefined> };

export type AuditResourceCellFragment = { __typename?: 'AuditResource', id: string, resourceId: string, resourceType: string, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'AuditEvent', id: string } | { __typename: 'AuditResource', id: string } | { __typename: 'Course', name: string, id: string } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } | { __typename: 'CourseEvent', name: string, id: string } | { __typename: 'CourseEventAttendance', id: string } | { __typename: 'CourseOptionBooking', id: string } | { __typename: 'CourseOptionDescriptor', name: string, id: string } | { __typename: 'CoursePart', name: string, id: string } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'DataProcessingActivity', id: string } | { __typename: 'DataProcessingAgreementChangeEvent', id: string } | { __typename: 'DataProcessingProcess', id: string } | { __typename: 'Document', id: string } | { __typename: 'DocumentTag', id: string } | { __typename: 'Expense', id: string } | { __typename: 'ExpenseDescriptor', id: string } | { __typename: 'ExpenseReceipt', id: string } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'Organization', name: string, id: string } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | { __typename: 'Payment', id: string } | { __typename: 'Person', displayName?: string | null | undefined, id: string } | { __typename: 'UserAccount', id: string } | null | undefined };

export type OrganizationSettingsDialogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationSettingsDialogQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', id: string, name: string, officialName: string, receiptsFooter?: string | null | undefined, membershipRequiresContribution: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type CreateOrganizationMutation = { __typename?: 'Mutation', createOrganization: { __typename?: 'Organization', id: string } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string, officialName: string, receiptsFooter?: string | null | undefined, membershipRequiresContribution: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } } };

export type OrganizationSettingsDialogCompFragment = { __typename?: 'Organization', id: string, name: string, officialName: string, receiptsFooter?: string | null | undefined, membershipRequiresContribution: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } };

export type DeleteOrganizationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteOrganizationMutation = { __typename?: 'Mutation', deleteOrganization: boolean };

export type CreatePersonMutationVariables = Exact<{ [key: string]: never; }>;


export type CreatePersonMutation = { __typename?: 'Mutation', createPerson: { __typename?: 'Person', id: string } };

export type GetAuthServiceUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthServiceUserAccountQuery = { __typename?: 'Query', viewerUserAccount?: { __typename?: 'UserAccount', id: string, mfa: boolean, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, roles: Array<UserRole>, isArchived: boolean } | null | undefined } } | null | undefined };

export type AuthServiceUserAccountFragment = { __typename?: 'UserAccount', id: string, mfa: boolean, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, roles: Array<UserRole>, isArchived: boolean } | null | undefined } };

export type OrganizationMenuQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMenuQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string }> };

export type OrganizationMenuItemFragment = { __typename?: 'Organization', id: string, name: string };

export type CreateCourseAdminFileMutationVariables = Exact<{
  input: CreateCourseAdminFileInput;
}>;


export type CreateCourseAdminFileMutation = { __typename?: 'Mutation', createCourseAdminFile: { __typename?: 'CourseAdminFile', id: string } };

export type CourseAdminGroupFormCompFragment = { __typename?: 'CourseAdminGroup', name: string };

export type CourseAdminFileRouteCompQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseAdminFileRouteCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, eventAttendances: Array<{ __typename?: 'CourseEventAttendance', id: string, customDuration?: any | null | undefined, event: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any, part: { __typename?: 'CoursePart', id: string, name: string } } }>, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined }, adminGroup: { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean, optionDescriptors: Array<{ __typename?: 'CourseOptionDescriptor', id: string, name: string }>, parts: Array<{ __typename?: 'CoursePart', id: string, events: Array<{ __typename?: 'CourseEvent', id: string }> }> }, optionBookings: Array<{ __typename?: 'CourseOptionBooking', id: string, canBeUpdated: boolean, canBeDeleted: boolean, expense: { __typename?: 'Expense', hasReceipt: boolean, id: string, nominal: { __typename?: 'Money', amount: number, currency: string }, discount: { __typename?: 'Money', amount: number, currency: string }, due: { __typename?: 'Money', amount: number, currency: string }, payed: { __typename?: 'Money', amount: number, currency: string }, balance: { __typename?: 'Money', amount: number, currency: string }, payments: Array<{ __typename?: 'Payment', id: string, method: PaymentMethod, receivedAt: any, amount: { __typename?: 'Money', amount: number, currency: string } }>, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } }, descriptor: { __typename?: 'CourseOptionDescriptor', name: string, description?: string | null | undefined } }>, expenseReceipts: Array<{ __typename?: 'ExpenseReceipt', id: string, databaseId: string, generatedAt: any, note: string, rescinded: boolean }>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type UpdateCourseAdminFileMutationVariables = Exact<{
  input: UpdateCourseAdminFileInput;
}>;


export type UpdateCourseAdminFileMutation = { __typename?: 'Mutation', updateCourseAdminFile: { __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, eventAttendances: Array<{ __typename?: 'CourseEventAttendance', id: string, customDuration?: any | null | undefined, event: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any, part: { __typename?: 'CoursePart', id: string, name: string } } }>, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined }, adminGroup: { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean, optionDescriptors: Array<{ __typename?: 'CourseOptionDescriptor', id: string, name: string }>, parts: Array<{ __typename?: 'CoursePart', id: string, events: Array<{ __typename?: 'CourseEvent', id: string }> }> }, optionBookings: Array<{ __typename?: 'CourseOptionBooking', id: string, canBeUpdated: boolean, canBeDeleted: boolean, expense: { __typename?: 'Expense', hasReceipt: boolean, id: string, nominal: { __typename?: 'Money', amount: number, currency: string }, discount: { __typename?: 'Money', amount: number, currency: string }, due: { __typename?: 'Money', amount: number, currency: string }, payed: { __typename?: 'Money', amount: number, currency: string }, balance: { __typename?: 'Money', amount: number, currency: string }, payments: Array<{ __typename?: 'Payment', id: string, method: PaymentMethod, receivedAt: any, amount: { __typename?: 'Money', amount: number, currency: string } }>, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } }, descriptor: { __typename?: 'CourseOptionDescriptor', name: string, description?: string | null | undefined } }>, expenseReceipts: Array<{ __typename?: 'ExpenseReceipt', id: string, databaseId: string, generatedAt: any, note: string, rescinded: boolean }>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } };

export type DeleteCourseAdminFileMutationVariables = Exact<{
  input: DeleteCourseAdminFileInput;
}>;


export type DeleteCourseAdminFileMutation = { __typename?: 'Mutation', deleteCourseAdminFile: boolean };

export type CreateCourseOptionBookingMutationVariables = Exact<{
  input: CreateCourseOptionBookingInput;
}>;


export type CreateCourseOptionBookingMutation = { __typename?: 'Mutation', createCourseOptionBooking: { __typename?: 'CourseOptionBooking', id: string } };

export type CreateCourseAdminFileExpenseReceiptMutationVariables = Exact<{
  input: CreateCourseAdminFileExpenseReceiptInput;
}>;


export type CreateCourseAdminFileExpenseReceiptMutation = { __typename?: 'Mutation', createCourseAdminFileExpenseReceipt: { __typename?: 'ExpenseReceipt', id: string } };

export type CourseAdminFileRouteFragment = { __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, eventAttendances: Array<{ __typename?: 'CourseEventAttendance', id: string, customDuration?: any | null | undefined, event: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any, part: { __typename?: 'CoursePart', id: string, name: string } } }>, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined }, adminGroup: { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean, optionDescriptors: Array<{ __typename?: 'CourseOptionDescriptor', id: string, name: string }>, parts: Array<{ __typename?: 'CoursePart', id: string, events: Array<{ __typename?: 'CourseEvent', id: string }> }> }, optionBookings: Array<{ __typename?: 'CourseOptionBooking', id: string, canBeUpdated: boolean, canBeDeleted: boolean, expense: { __typename?: 'Expense', hasReceipt: boolean, id: string, nominal: { __typename?: 'Money', amount: number, currency: string }, discount: { __typename?: 'Money', amount: number, currency: string }, due: { __typename?: 'Money', amount: number, currency: string }, payed: { __typename?: 'Money', amount: number, currency: string }, balance: { __typename?: 'Money', amount: number, currency: string }, payments: Array<{ __typename?: 'Payment', id: string, method: PaymentMethod, receivedAt: any, amount: { __typename?: 'Money', amount: number, currency: string } }>, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } }, descriptor: { __typename?: 'CourseOptionDescriptor', name: string, description?: string | null | undefined } }>, expenseReceipts: Array<{ __typename?: 'ExpenseReceipt', id: string, databaseId: string, generatedAt: any, note: string, rescinded: boolean }>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } };

export type CourseAdminGroupDialogCompQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseAdminGroupDialogCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup', id: string, name: string, isArchived: boolean, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, course: { __typename?: 'Course', id: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, parts: Array<{ __typename?: 'CoursePart', id: string }> }> } } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateCourseAdminGroupMutationVariables = Exact<{
  input: CreateCourseAdminGroupInput;
}>;


export type CreateCourseAdminGroupMutation = { __typename?: 'Mutation', createCourseAdminGroup: { __typename?: 'CourseAdminGroup', id: string, name: string, isArchived: boolean, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, course: { __typename?: 'Course', id: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, parts: Array<{ __typename?: 'CoursePart', id: string }> }> } } };

export type UpdateCourseAdminGroupMutationVariables = Exact<{
  input: UpdateCourseAdminGroupInput;
}>;


export type UpdateCourseAdminGroupMutation = { __typename?: 'Mutation', updateCourseAdminGroup: { __typename?: 'CourseAdminGroup', id: string, name: string, isArchived: boolean, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, course: { __typename?: 'Course', id: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, parts: Array<{ __typename?: 'CoursePart', id: string }> }> } } };

export type CourseAdminGroupDialogFragment = { __typename?: 'CourseAdminGroup', id: string, name: string, isArchived: boolean, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, course: { __typename?: 'Course', id: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, parts: Array<{ __typename?: 'CoursePart', id: string }> }> } };

export type CourseAdminGroupRouteCompQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseAdminGroupRouteCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup', id: string, name: string, canBeDeleted: boolean, isArchived: boolean, course: { __typename?: 'Course', id: string, name: string }, parts: Array<{ __typename?: 'CoursePart', id: string }>, adminFiles: Array<{ __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined, name?: { __typename?: 'PersonName', familyName: string, givenName: string } | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } }> } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type DeleteCourseAdminGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCourseAdminGroupMutation = { __typename?: 'Mutation', deleteCourseAdminGroup: boolean };

export type UpdateCourseAdminGroupIsArchivedMutationVariables = Exact<{
  id: Scalars['ID'];
  isArchived: Scalars['Boolean'];
}>;


export type UpdateCourseAdminGroupIsArchivedMutation = { __typename?: 'Mutation', updateCourseAdminGroup: { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean } };

export type ArchiveCourseAdminFileMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveCourseAdminFileMutation = { __typename?: 'Mutation', updateCourseAdminFile: { __typename?: 'CourseAdminFile', id: string, isArchived: boolean } };

export type CourseAdminGroupRouteFragment = { __typename?: 'CourseAdminGroup', id: string, name: string, canBeDeleted: boolean, isArchived: boolean, course: { __typename?: 'Course', id: string, name: string }, parts: Array<{ __typename?: 'CoursePart', id: string }>, adminFiles: Array<{ __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined, name?: { __typename?: 'PersonName', familyName: string, givenName: string } | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } }> };

export type AdminGroupRouteAdminFileFragment = { __typename?: 'CourseAdminFile', id: string, isArchived: boolean, isRescinded: boolean, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined, name?: { __typename?: 'PersonName', familyName: string, givenName: string } | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } };

export type CourseDialogCompQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseDialogCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course', id: string, name: string, level: CourseLevel } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateCourseMutationVariables = Exact<{
  input: CreateCourseInput;
}>;


export type CreateCourseMutation = { __typename?: 'Mutation', createCourse: { __typename?: 'Course', id: string, name: string, level: CourseLevel } };

export type UpdateCourseMutationVariables = Exact<{
  input: UpdateCourseInput;
}>;


export type UpdateCourseMutation = { __typename?: 'Mutation', updateCourse: { __typename?: 'Course', id: string, name: string, level: CourseLevel } };

export type CourseDialogCourseFragment = { __typename?: 'Course', id: string, name: string, level: CourseLevel };

export type CourseListItemCompFragment = { __typename?: 'Course', id: string, canBeDeleted: boolean, level: CourseLevel, name: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, name: string }> };

export type CourseListRouteQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
}>;


export type CourseListRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', id: string, courses: { __typename?: 'CourseConnection', courseEdges: Array<{ __typename?: 'CourseEdge', node: { __typename?: 'Course', id: string, canBeDeleted: boolean, level: CourseLevel, name: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CourseEdge', cursor: string }> } } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CourseListRouteCompFragment = { __typename?: 'Organization', id: string, courses: { __typename?: 'CourseConnection', courseEdges: Array<{ __typename?: 'CourseEdge', node: { __typename?: 'Course', id: string, canBeDeleted: boolean, level: CourseLevel, name: string, parts: Array<{ __typename?: 'CoursePart', id: string, name: string }>, adminGroups: Array<{ __typename?: 'CourseAdminGroup', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CourseEdge', cursor: string }> } };

export type DeleteCourseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCourseMutation = { __typename?: 'Mutation', deleteCourse: boolean };

export type UpdateCourseOptionBookingMutationVariables = Exact<{
  input: UpdateCourseOptionBookingInput;
}>;


export type UpdateCourseOptionBookingMutation = { __typename?: 'Mutation', updateCourseOptionBooking: { __typename?: 'CourseOptionBooking', id: string, canBeUpdated: boolean, canBeDeleted: boolean, descriptor: { __typename?: 'CourseOptionDescriptor', name: string, description?: string | null | undefined }, expense: { __typename?: 'Expense', id: string, nominal: { __typename?: 'Money', amount: number, currency: string }, discount: { __typename?: 'Money', amount: number, currency: string }, due: { __typename?: 'Money', amount: number, currency: string }, payed: { __typename?: 'Money', amount: number, currency: string }, balance: { __typename?: 'Money', amount: number, currency: string }, payments: Array<{ __typename?: 'Payment', id: string, method: PaymentMethod, receivedAt: any, amount: { __typename?: 'Money', amount: number, currency: string } }>, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } } } };

export type DeleteCourseOptionBookingMutationVariables = Exact<{
  input: DeleteCourseOptionBookingInput;
}>;


export type DeleteCourseOptionBookingMutation = { __typename?: 'Mutation', deleteCourseOptionBooking: boolean };

export type DeleteCourseOptionBookingPaymentMutationVariables = Exact<{
  input: DeleteCourseOptionBookingPaymentInput;
}>;


export type DeleteCourseOptionBookingPaymentMutation = { __typename?: 'Mutation', deleteCourseOptionBookingPayment: boolean };

export type CourseOptionBookingCompFragment = { __typename?: 'CourseOptionBooking', id: string, canBeUpdated: boolean, canBeDeleted: boolean, descriptor: { __typename?: 'CourseOptionDescriptor', name: string, description?: string | null | undefined }, expense: { __typename?: 'Expense', id: string, nominal: { __typename?: 'Money', amount: number, currency: string }, discount: { __typename?: 'Money', amount: number, currency: string }, due: { __typename?: 'Money', amount: number, currency: string }, payed: { __typename?: 'Money', amount: number, currency: string }, balance: { __typename?: 'Money', amount: number, currency: string }, payments: Array<{ __typename?: 'Payment', id: string, method: PaymentMethod, receivedAt: any, amount: { __typename?: 'Money', amount: number, currency: string } }>, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } } };

export type CreateCourseOptionDescriptorMutationVariables = Exact<{
  input: CreateCourseOptionDescriptorInput;
}>;


export type CreateCourseOptionDescriptorMutation = { __typename?: 'Mutation', createCourseOptionDescriptor: { __typename?: 'CourseOptionDescriptor', id: string, canBeDeleted: boolean, canBeUpdated: boolean, name: string, description?: string | null | undefined, expenseDescriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', amount: number, currency: string } } } };

export type UpdateCourseOptionDescriptorMutationVariables = Exact<{
  input: UpdateCourseOptionDescriptorInput;
}>;


export type UpdateCourseOptionDescriptorMutation = { __typename?: 'Mutation', updateCourseOptionDescriptor: { __typename?: 'CourseOptionDescriptor', id: string, canBeDeleted: boolean, canBeUpdated: boolean, name: string, description?: string | null | undefined, expenseDescriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', amount: number, currency: string } } } };

export type DeleteCourseOptionDescriptorMutationVariables = Exact<{
  input: DeleteCourseOptionDescriptorInput;
}>;


export type DeleteCourseOptionDescriptorMutation = { __typename?: 'Mutation', deleteCourseOptionDescriptor: boolean };

export type CourseOptionDescriptorFormFragment = { __typename?: 'CourseOptionDescriptor', id: string, canBeDeleted: boolean, canBeUpdated: boolean, name: string, description?: string | null | undefined, expenseDescriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', amount: number, currency: string } } };

export type CourseOptionDescriptorsDialogQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CourseOptionDescriptorsDialogQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean, optionDescriptors: Array<{ __typename?: 'CourseOptionDescriptor', id: string, canBeDeleted: boolean, canBeUpdated: boolean, name: string, description?: string | null | undefined, expenseDescriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', amount: number, currency: string } } }> } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CourseOptionDescriptorsDialogCompFragment = { __typename?: 'CourseAdminGroup', id: string, isArchived: boolean, optionDescriptors: Array<{ __typename?: 'CourseOptionDescriptor', id: string, canBeDeleted: boolean, canBeUpdated: boolean, name: string, description?: string | null | undefined, expenseDescriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', amount: number, currency: string } } }> };

export type CoursePartDialogCompQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CoursePartDialogCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart', id: string, name: string, startDate: any, endDate: any, events: Array<{ __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any }> } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateCoursePartMutationVariables = Exact<{
  input: CreateCoursePartInput;
}>;


export type CreateCoursePartMutation = { __typename?: 'Mutation', createCoursePart: { __typename?: 'CoursePart', id: string, name: string, startDate: any, endDate: any, events: Array<{ __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any }> } };

export type UpdateCoursePartMutationVariables = Exact<{
  input: UpdateCoursePartInput;
}>;


export type UpdateCoursePartMutation = { __typename?: 'Mutation', updateCoursePart: { __typename?: 'CoursePart', id: string, name: string, startDate: any, endDate: any, events: Array<{ __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any }> } };

export type DeleteCoursePartMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCoursePartMutation = { __typename?: 'Mutation', deleteCoursePart: boolean };

export type CreateCourseEventMutationVariables = Exact<{
  input: CreateCourseEventInput;
}>;


export type CreateCourseEventMutation = { __typename?: 'Mutation', createCourseEvent: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any } };

export type UpdateCourseEventMutationVariables = Exact<{
  input: UpdateCourseEventInput;
}>;


export type UpdateCourseEventMutation = { __typename?: 'Mutation', updateCourseEvent: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any } };

export type DeleteCourseEventMutationVariables = Exact<{
  input: DeleteCourseEventInput;
}>;


export type DeleteCourseEventMutation = { __typename?: 'Mutation', deleteCourseEvent: boolean };

export type CoursePartDialogCoursePartFragment = { __typename?: 'CoursePart', id: string, name: string, startDate: any, endDate: any, events: Array<{ __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any }> };

export type CoursePartDialogEventFragment = { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any };

export type CreateCourseOptionBookingPaymentMutationVariables = Exact<{
  input: CreateCourseOptionBookingPaymentInput;
}>;


export type CreateCourseOptionBookingPaymentMutation = { __typename?: 'Mutation', createCourseOptionBookingPayment: { __typename?: 'Payment', id: string } };

export type CreatePaymentDialogFragment = { __typename?: 'CourseOptionBooking', id: string, expense: { __typename?: 'Expense', id: string, descriptor: { __typename?: 'ExpenseDescriptor', id: string, amount: { __typename?: 'Money', currency: string } } } };

export type EventAttendanceListItemFragment = { __typename?: 'CourseEventAttendance', id: string, customDuration?: any | null | undefined, event: { __typename?: 'CourseEvent', id: string, name: string, startDate: any, endDate: any, part: { __typename?: 'CoursePart', id: string, name: string } } };

export type UpdateCourseAdminFileExpenseReceiptMutationVariables = Exact<{
  input: UpdateCourseAdminFileExpenseReceiptInput;
}>;


export type UpdateCourseAdminFileExpenseReceiptMutation = { __typename?: 'Mutation', updateCourseAdminFileExpenseReceipt: { __typename?: 'ExpenseReceipt', id: string, databaseId: string, generatedAt: any, note: string, rescinded: boolean } };

export type DeleteCourseAdminFileExpenseReceiptMutationVariables = Exact<{
  input: DeleteCourseAdminFileExpenseReceiptInput;
}>;


export type DeleteCourseAdminFileExpenseReceiptMutation = { __typename?: 'Mutation', deleteCourseAdminFileExpenseReceipt: boolean };

export type CourseAdminFileExpenseReceiptFragment = { __typename?: 'ExpenseReceipt', id: string, databaseId: string, generatedAt: any, note: string, rescinded: boolean };

export type DocumentTableRowFragment = { __typename?: 'Document', id: string, createdAt: any, name: string, tags: Array<{ __typename?: 'DocumentTag', id: string, name: string }> };

export type DocumentListPageConnectionFragment = { __typename?: 'DocumentConnection', documentEdges: Array<{ __typename?: 'DocumentEdge', node: { __typename?: 'Document', id: string, createdAt: any, name: string, tags: Array<{ __typename?: 'DocumentTag', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DocumentEdge', cursor: string }> };

export type DocumentListPageCompQueryVariables = Exact<{
  organizationId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  orderBy: DocumentOrderBy;
  orderDirection: OrderDirection;
}>;


export type DocumentListPageCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', documentTags: Array<{ __typename?: 'DocumentTag', id: string, name: string }>, documents: { __typename?: 'DocumentConnection', documentEdges: Array<{ __typename?: 'DocumentEdge', node: { __typename?: 'Document', id: string, createdAt: any, name: string, tags: Array<{ __typename?: 'DocumentTag', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DocumentEdge', cursor: string }> } } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type UpdateDocumentMutationVariables = Exact<{
  input: UpdateDocumentInput;
}>;


export type UpdateDocumentMutation = { __typename?: 'Mutation', updateDocument: { __typename?: 'Document', id: string, createdAt: any, name: string, tags: Array<{ __typename?: 'DocumentTag', id: string, name: string }> } };

export type DeleteDocumentMutationVariables = Exact<{
  input: DeleteDocumentInput;
}>;


export type DeleteDocumentMutation = { __typename?: 'Mutation', deleteDocument: boolean };

export type DocumentTagsDialogCompQueryVariables = Exact<{
  organizationId: Scalars['ID'];
}>;


export type DocumentTagsDialogCompQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', documentTags: Array<{ __typename?: 'DocumentTag', id: string, name: string }> } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateDocumentTagMutationVariables = Exact<{
  input: CreateDocumentTagInput;
}>;


export type CreateDocumentTagMutation = { __typename?: 'Mutation', createDocumentTag: { __typename?: 'DocumentTag', id: string, name: string } };

export type UpdateDocumentTagMutationVariables = Exact<{
  input: UpdateDocumentTagInput;
}>;


export type UpdateDocumentTagMutation = { __typename?: 'Mutation', updateDocumentTag: { __typename?: 'DocumentTag', id: string, name: string } };

export type DeleteDocumentTagMutationVariables = Exact<{
  input: DeleteDocumentTagInput;
}>;


export type DeleteDocumentTagMutation = { __typename?: 'Mutation', deleteDocumentTag: boolean };

export type DocumentTagsDialogTagFragment = { __typename?: 'DocumentTag', id: string, name: string };

export type DocumentUploadTagFragment = { __typename?: 'DocumentTag', id: string, name: string };

export type OrganizationDashboardQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrganizationDashboardQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', id: string, name: string, officialName: string, courses: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined } } } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type OrganizationDashboardMembershipsQueryVariables = Exact<{
  id: Scalars['ID'];
  first: Scalars['Int'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationDashboardMembershipsQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization', id: string, memberships: { __typename?: 'OrganizationMembershipConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalEdges?: number | null | undefined }, edges: Array<{ __typename?: 'OrganizationMembershipEdge', cursor: string, node: { __typename?: 'OrganizationMembership', id: string, startDate: any, person: { __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } } }> } } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type DashboardOrganizationFragment = { __typename?: 'Organization', id: string, name: string, officialName: string, courses: { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined } } };

export type DashboardOrganizationMembershipsFragment = { __typename?: 'OrganizationMembershipConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalEdges?: number | null | undefined }, edges: Array<{ __typename?: 'OrganizationMembershipEdge', cursor: string, node: { __typename?: 'OrganizationMembership', id: string, startDate: any, person: { __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } } }> };

export type DashboardOrganizationMembershipFragment = { __typename?: 'OrganizationMembership', id: string, startDate: any, person: { __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } };

export type CertificateRouteQueryVariables = Exact<{
  certificateId: Scalars['ID'];
}>;


export type CertificateRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number, duration?: any | null | undefined }, adminFile?: { __typename?: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', id: string, course: { __typename?: 'Course', id: string, organization: { __typename?: 'Organization', id: string } } } } | null | undefined } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CertificateRouteCertificateFragment = { __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number, duration?: any | null | undefined }, adminFile?: { __typename?: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', id: string, course: { __typename?: 'Course', id: string, organization: { __typename?: 'Organization', id: string } } } } | null | undefined };

export type CreateCourseParticipationCertificateMutationVariables = Exact<{
  input: CreateCourseParticipationCertificateInput;
}>;


export type CreateCourseParticipationCertificateMutation = { __typename?: 'Mutation', createCourseParticipationCertificate: { __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number, duration?: any | null | undefined }, adminFile?: { __typename?: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', id: string, course: { __typename?: 'Course', id: string, organization: { __typename?: 'Organization', id: string } } } } | null | undefined } };

export type UpdateCourseParticipationCertificateMutationVariables = Exact<{
  input: UpdateCourseParticipationCertificateInput;
}>;


export type UpdateCourseParticipationCertificateMutation = { __typename?: 'Mutation', updateCourseParticipationCertificate: { __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number, duration?: any | null | undefined }, adminFile?: { __typename?: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', id: string, course: { __typename?: 'Course', id: string, organization: { __typename?: 'Organization', id: string } } } } | null | undefined } };

export type DeleteCourseParticipationCertificateMutationVariables = Exact<{
  input: DeleteCourseParticipationCertificateInput;
}>;


export type DeleteCourseParticipationCertificateMutation = { __typename?: 'Mutation', deleteCourseParticipationCertificate: boolean };

export type CertificatesRouteQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type CertificatesRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, courseParticipationCertificates: Array<{ __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number } }> } | { __typename?: 'UserAccount' } };

export type CertificatesRouteCertificateFragment = { __typename?: 'CourseParticipationCertificate', id: string, hasDocument: boolean, completion?: number | null | undefined, courseSummary: { __typename?: 'CourseParticipationCourseSummary', name: string, level: CourseLevel, part: string, year: number } };

export type CorePersonalDataRouteFragment = { __typename?: 'Person', id: string, displayName?: string | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, roles: Array<UserRole> } | null | undefined, name?: { __typename?: 'PersonName', canBeDeleted: boolean, givenName: string, familyName: string } | null | undefined, email?: { __typename?: 'PersonEmail', canBeDeleted: boolean, emailAddress: string } | null | undefined, phone?: { __typename?: 'PersonPhone', canBeDeleted: boolean, primaryNumber: string, secondaryNumber?: string | null | undefined } | null | undefined, homeAddress?: { __typename?: 'PersonAddress', canBeDeleted: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } } | null | undefined };

export type CorePersonalDataRouteQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type CorePersonalDataRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, displayName?: string | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, roles: Array<UserRole> } | null | undefined, name?: { __typename?: 'PersonName', canBeDeleted: boolean, givenName: string, familyName: string } | null | undefined, email?: { __typename?: 'PersonEmail', canBeDeleted: boolean, emailAddress: string } | null | undefined, phone?: { __typename?: 'PersonPhone', canBeDeleted: boolean, primaryNumber: string, secondaryNumber?: string | null | undefined } | null | undefined, homeAddress?: { __typename?: 'PersonAddress', canBeDeleted: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } } | null | undefined } | { __typename?: 'UserAccount' } };

export type UpdatePersonMutationVariables = Exact<{
  input: UpdatePersonInput;
}>;


export type UpdatePersonMutation = { __typename?: 'Mutation', updatePerson: { __typename?: 'Person', id: string, displayName?: string | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, roles: Array<UserRole> } | null | undefined, name?: { __typename?: 'PersonName', canBeDeleted: boolean, givenName: string, familyName: string } | null | undefined, email?: { __typename?: 'PersonEmail', canBeDeleted: boolean, emailAddress: string } | null | undefined, phone?: { __typename?: 'PersonPhone', canBeDeleted: boolean, primaryNumber: string, secondaryNumber?: string | null | undefined } | null | undefined, homeAddress?: { __typename?: 'PersonAddress', canBeDeleted: boolean, address: { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string } } | null | undefined } };

export type DpaRouteActivityFragment = { __typename?: 'DataProcessingActivity', id: string, name: string };

export type DpaRouteActivitesQueryVariables = Exact<{ [key: string]: never; }>;


export type DpaRouteActivitesQuery = { __typename?: 'Query', dataProcessingActivities: Array<{ __typename?: 'DataProcessingActivity', id: string, name: string }> };

export type DpaRouteChangeEventFragment = { __typename?: 'DataProcessingAgreementChangeEvent', id: string, date: any, isManaged: boolean, hasDocumentation: boolean, changes: Array<{ __typename?: 'DataProcessingAgreementChange', permissionStatus: DataProcessingAgreementPermissionStatus, activity: { __typename?: 'DataProcessingActivity', id: string, name: string } }> };

export type DpaRouteChangeEventsQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type DpaRouteChangeEventsQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, dataProcessingAgreementChangeEvents: Array<{ __typename?: 'DataProcessingAgreementChangeEvent', id: string, date: any, isManaged: boolean, hasDocumentation: boolean, changes: Array<{ __typename?: 'DataProcessingAgreementChange', permissionStatus: DataProcessingAgreementPermissionStatus, activity: { __typename?: 'DataProcessingActivity', id: string, name: string } }> }> } | { __typename?: 'UserAccount' } };

export type DpaRouteChangeEventQueryVariables = Exact<{
  eventId: Scalars['ID'];
}>;


export type DpaRouteChangeEventQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent', id: string, date: any, isManaged: boolean, hasDocumentation: boolean, changes: Array<{ __typename?: 'DataProcessingAgreementChange', permissionStatus: DataProcessingAgreementPermissionStatus, activity: { __typename?: 'DataProcessingActivity', id: string, name: string } }> } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type CreateDataProcessingAgreementChangeEventMutationVariables = Exact<{
  input: CreateDataProcessingAgreementChangeEventInput;
}>;


export type CreateDataProcessingAgreementChangeEventMutation = { __typename?: 'Mutation', createDataProcessingAgreementChangeEvent?: { __typename?: 'DataProcessingAgreementChangeEvent', id: string, date: any, isManaged: boolean, hasDocumentation: boolean, changes: Array<{ __typename?: 'DataProcessingAgreementChange', permissionStatus: DataProcessingAgreementPermissionStatus, activity: { __typename?: 'DataProcessingActivity', id: string, name: string } }> } | null | undefined };

export type UpdateDataProcessingAgreementChangeEventMutationVariables = Exact<{
  input: UpdateDataProcessingAgreementChangeEventInput;
}>;


export type UpdateDataProcessingAgreementChangeEventMutation = { __typename?: 'Mutation', updateDataProcessingAgreementChangeEvent?: { __typename?: 'DataProcessingAgreementChangeEvent', id: string, date: any, isManaged: boolean, hasDocumentation: boolean, changes: Array<{ __typename?: 'DataProcessingAgreementChange', permissionStatus: DataProcessingAgreementPermissionStatus, activity: { __typename?: 'DataProcessingActivity', id: string, name: string } }> } | null | undefined };

export type DeleteDataProcessingAgreementChangeEventMutationVariables = Exact<{
  input: DeleteDataProcessingAgreementChangeEventInput;
}>;


export type DeleteDataProcessingAgreementChangeEventMutation = { __typename?: 'Mutation', deleteDataProcessingAgreementChangeEvent?: boolean | null | undefined };

export type MembershipRouteQueryVariables = Exact<{
  membershipId: Scalars['ID'];
}>;


export type MembershipRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership', id: string, startDate: any, endDate?: any | null | undefined, isActive: boolean, hasAttachment: boolean, organization: { __typename?: 'Organization', id: string, name: string } } | { __typename?: 'Payment' } | { __typename?: 'Person' } | { __typename?: 'UserAccount' } };

export type MembershipRouteMembershipFragment = { __typename?: 'OrganizationMembership', id: string, startDate: any, endDate?: any | null | undefined, isActive: boolean, hasAttachment: boolean, organization: { __typename?: 'Organization', id: string, name: string } };

export type UpdateOrganizaionMembershipMutationVariables = Exact<{
  input: UpdateOrganizationMembershipInput;
}>;


export type UpdateOrganizaionMembershipMutation = { __typename?: 'Mutation', updateOrganizationMembership: { __typename?: 'OrganizationMembership', id: string, startDate: any, endDate?: any | null | undefined, isActive: boolean, hasAttachment: boolean, organization: { __typename?: 'Organization', id: string, name: string } } };

export type DeletOrganizaionMembershipMutationVariables = Exact<{
  input: DeleteOrganizationMembershipInput;
}>;


export type DeletOrganizaionMembershipMutation = { __typename?: 'Mutation', deleteOrganizationMembership: boolean };

export type MembershipsRouteQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type MembershipsRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, organizationMemberships: Array<{ __typename?: 'OrganizationMembership', id: string, startDate: any, endDate?: any | null | undefined, isActive: boolean, organization: { __typename?: 'Organization', id: string, name: string } }> } | { __typename?: 'UserAccount' } };

export type MembershipsRouteMembershipFragment = { __typename?: 'OrganizationMembership', id: string, startDate: any, endDate?: any | null | undefined, isActive: boolean, organization: { __typename?: 'Organization', id: string, name: string } };

export type NewMembershipRouteQueryVariables = Exact<{ [key: string]: never; }>;


export type NewMembershipRouteQuery = { __typename?: 'Query', organizations: Array<{ __typename?: 'Organization', id: string, name: string }> };

export type CreateOrganizaionMembershipMutationVariables = Exact<{
  input: CreateOrganizationMembershipInput;
}>;


export type CreateOrganizaionMembershipMutation = { __typename?: 'Mutation', createOrganizationMembership: { __typename?: 'OrganizationMembership', id: string } };

export type PersonFiltersFormDpaFragment = { __typename?: 'DataProcessingActivity', id: string, name: string };

export type PersonFiltersFormOrganizationFragment = { __typename?: 'Organization', id: string, name: string };

export type PersonListRouteQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  last?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<PersonFilters>;
}>;


export type PersonListRouteQuery = { __typename?: 'Query', persons: { __typename?: 'PersonConnection', personEdges: Array<{ __typename?: 'PersonEdge', cursor: string, node: { __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PersonEdge', cursor: string }> }, dataProcessingActivities: Array<{ __typename?: 'DataProcessingActivity', id: string, name: string }>, organizations: Array<{ __typename?: 'Organization', id: string, name: string }> };

export type FetchFilteredPersonsEmailsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<PersonFilters>;
}>;


export type FetchFilteredPersonsEmailsQuery = { __typename?: 'Query', persons: { __typename?: 'PersonConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'PersonEdge', cursor: string, node: { __typename?: 'Person', id: string, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } }> } };

export type PersonListRouteSearchQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type PersonListRouteSearchQuery = { __typename?: 'Query', personSearch: Array<{ __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined }> };

export type PersonListRoutePersonFragment = { __typename?: 'Person', id: string, databaseId: string, displayName?: string | null | undefined };

export type PersonRouteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, displayName?: string | null | undefined, canBeDeleted: boolean } | { __typename?: 'UserAccount' } };

export type PersonRouteFragment = { __typename?: 'Person', id: string, displayName?: string | null | undefined, canBeDeleted: boolean };

export type DeletePersonMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeletePersonMutation = { __typename?: 'Mutation', deletePerson: boolean };

export type ProcessTableQueryVariables = Exact<{
  personId: Scalars['ID'];
  after?: InputMaybe<Scalars['String']>;
}>;


export type ProcessTableQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, dataProcessingProcesses: { __typename?: 'DataProcessingProcessConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DataProcessingProcessEdge', cursor: string, node: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState, start: any, retentionStart?: any | null | undefined, retentionEnd?: any | null | undefined, permissionExists?: boolean | null | undefined, activity: { __typename?: 'DataProcessingActivity', id: string, name: string }, retentionConfig?: { __typename?: 'ProcessRetentionConfig', startAdjuster: RetentionStartAdjuster, duration: number, unit: TimeUnit } | null | undefined, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | null | undefined } }> } } | { __typename?: 'UserAccount' } };

export type ProcessTableFragment = { __typename?: 'Person', id: string, dataProcessingProcesses: { __typename?: 'DataProcessingProcessConnection', pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean }, edges: Array<{ __typename?: 'DataProcessingProcessEdge', cursor: string, node: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState, start: any, retentionStart?: any | null | undefined, retentionEnd?: any | null | undefined, permissionExists?: boolean | null | undefined, activity: { __typename?: 'DataProcessingActivity', id: string, name: string }, retentionConfig?: { __typename?: 'ProcessRetentionConfig', startAdjuster: RetentionStartAdjuster, duration: number, unit: TimeUnit } | null | undefined, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | null | undefined } }> } };

export type ProcessTableProcessFragment = { __typename?: 'DataProcessingProcess', id: string, state: ProcessState, start: any, retentionStart?: any | null | undefined, retentionEnd?: any | null | undefined, permissionExists?: boolean | null | undefined, activity: { __typename?: 'DataProcessingActivity', id: string, name: string }, retentionConfig?: { __typename?: 'ProcessRetentionConfig', startAdjuster: RetentionStartAdjuster, duration: number, unit: TimeUnit } | null | undefined, resource?: { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } } | { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } } | { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } } | { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } } | null | undefined };

export type UserAccountRouteFragment = { __typename?: 'Person', id: string, userAccount?: { __typename?: 'UserAccount', id: string, mfa: boolean } | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, isArchived: boolean, roles: Array<UserRole>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } | null | undefined, memberPortalUser?: { __typename?: 'MemberPortalUser', id: string, materialAccessCourseLevels: Array<CourseLevel>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } | null | undefined };

export type UserAccountRouteQueryVariables = Exact<{
  personId: Scalars['ID'];
}>;


export type UserAccountRouteQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, userAccount?: { __typename?: 'UserAccount', id: string, mfa: boolean } | null | undefined, adminAppUser?: { __typename?: 'AdminAppUser', id: string, isArchived: boolean, roles: Array<UserRole>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } | null | undefined, memberPortalUser?: { __typename?: 'MemberPortalUser', id: string, materialAccessCourseLevels: Array<CourseLevel>, process: { __typename?: 'DataProcessingProcess', id: string, state: ProcessState } } | null | undefined } | { __typename?: 'UserAccount' } };

export type UpdateUserAccountMutationVariables = Exact<{
  input: UpdateUserAccountInput;
}>;


export type UpdateUserAccountMutation = { __typename?: 'Mutation', updateUserAccount: { __typename?: 'UserAccount', id: string, mfa: boolean } };

export type CreateAdminAppUserMutationVariables = Exact<{
  input: CreateAdminAppUserInput;
}>;


export type CreateAdminAppUserMutation = { __typename?: 'Mutation', createAdminAppUser: { __typename?: 'AdminAppUser', id: string } };

export type UpdateAdminAppUserMutationVariables = Exact<{
  input: UpdateAdminAppUserInput;
}>;


export type UpdateAdminAppUserMutation = { __typename?: 'Mutation', updateAdminAppUser: { __typename?: 'AdminAppUser', id: string, isArchived: boolean, roles: Array<UserRole> } };

export type DeleteAdminAppUserMutationVariables = Exact<{
  input: DeleteAdminAppUserInput;
}>;


export type DeleteAdminAppUserMutation = { __typename?: 'Mutation', deleteAdminAppUser: boolean };

export type CreateMemberPortalUserMutationVariables = Exact<{
  input: CreateMemberPortalUserInput;
}>;


export type CreateMemberPortalUserMutation = { __typename?: 'Mutation', createMemberPortalUser: { __typename?: 'MemberPortalUser', id: string, materialAccessCourseLevels: Array<CourseLevel> } };

export type UpdateMemberPortalUserMutationVariables = Exact<{
  input: UpdateMemberPortalUserInput;
}>;


export type UpdateMemberPortalUserMutation = { __typename?: 'Mutation', updateMemberPortalUser: { __typename?: 'MemberPortalUser', id: string, materialAccessCourseLevels: Array<CourseLevel> } };

export type DeleteMemberPortalUserMutationVariables = Exact<{
  input: DeleteMemberPortalUserInput;
}>;


export type DeleteMemberPortalUserMutation = { __typename?: 'Mutation', deleteMemberPortalUser: boolean };

export type PostalAddressFormCompFragment = { __typename?: 'PostalAddress', addressLine1: string, addressLine2?: string | null | undefined, postalCode: string, city: string, area?: string | null | undefined, country: string };

type EntityTimestamps_AdminAppUser_Fragment = { __typename?: 'AdminAppUser', createdAt: any, modifiedAt: any };

type EntityTimestamps_Course_Fragment = { __typename?: 'Course', createdAt: any, modifiedAt: any };

type EntityTimestamps_CourseAdminFile_Fragment = { __typename?: 'CourseAdminFile', createdAt: any, modifiedAt: any };

type EntityTimestamps_CourseAdminGroup_Fragment = { __typename?: 'CourseAdminGroup', createdAt: any, modifiedAt: any };

type EntityTimestamps_CoursePart_Fragment = { __typename?: 'CoursePart', createdAt: any, modifiedAt: any };

type EntityTimestamps_Document_Fragment = { __typename?: 'Document', createdAt: any, modifiedAt: any };

type EntityTimestamps_DocumentTag_Fragment = { __typename?: 'DocumentTag', createdAt: any, modifiedAt: any };

type EntityTimestamps_MemberPortalUser_Fragment = { __typename?: 'MemberPortalUser', createdAt: any, modifiedAt: any };

type EntityTimestamps_Organization_Fragment = { __typename?: 'Organization', createdAt: any, modifiedAt: any };

type EntityTimestamps_OrganizationMembership_Fragment = { __typename?: 'OrganizationMembership', createdAt: any, modifiedAt: any };

type EntityTimestamps_Person_Fragment = { __typename?: 'Person', createdAt: any, modifiedAt: any };

export type EntityTimestampsFragment = EntityTimestamps_AdminAppUser_Fragment | EntityTimestamps_Course_Fragment | EntityTimestamps_CourseAdminFile_Fragment | EntityTimestamps_CourseAdminGroup_Fragment | EntityTimestamps_CoursePart_Fragment | EntityTimestamps_Document_Fragment | EntityTimestamps_DocumentTag_Fragment | EntityTimestamps_MemberPortalUser_Fragment | EntityTimestamps_Organization_Fragment | EntityTimestamps_OrganizationMembership_Fragment | EntityTimestamps_Person_Fragment;

type ListPagingControls_AuditEventConnection_Fragment = { __typename?: 'AuditEventConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'AuditEventEdge', cursor: string }> };

type ListPagingControls_CourseConnection_Fragment = { __typename?: 'CourseConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'CourseEdge', cursor: string }> };

type ListPagingControls_DataProcessingProcessConnection_Fragment = { __typename?: 'DataProcessingProcessConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DataProcessingProcessEdge', cursor: string }> };

type ListPagingControls_DocumentConnection_Fragment = { __typename?: 'DocumentConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'DocumentEdge', cursor: string }> };

type ListPagingControls_OrganizationMembershipConnection_Fragment = { __typename?: 'OrganizationMembershipConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'OrganizationMembershipEdge', cursor: string }> };

type ListPagingControls_PersonConnection_Fragment = { __typename?: 'PersonConnection', pageInfo: { __typename?: 'PageInfo', totalEdges?: number | null | undefined, totalPages?: number | null | undefined, page?: number | null | undefined, size: number, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ __typename?: 'PersonEdge', cursor: string }> };

export type ListPagingControlsFragment = ListPagingControls_AuditEventConnection_Fragment | ListPagingControls_CourseConnection_Fragment | ListPagingControls_DataProcessingProcessConnection_Fragment | ListPagingControls_DocumentConnection_Fragment | ListPagingControls_OrganizationMembershipConnection_Fragment | ListPagingControls_PersonConnection_Fragment;

export type MoneyCompFragment = { __typename?: 'Money', amount: number, currency: string };

export type PersonPickerQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type PersonPickerQuery = { __typename?: 'Query', personSearch: Array<{ __typename?: 'Person', id: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined }> };

export type PersonPickerByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PersonPickerByIdQuery = { __typename?: 'Query', node: { __typename?: 'AdminAppUser' } | { __typename?: 'AuditEvent' } | { __typename?: 'AuditResource' } | { __typename?: 'Course' } | { __typename?: 'CourseAdminFile' } | { __typename?: 'CourseAdminGroup' } | { __typename?: 'CourseEvent' } | { __typename?: 'CourseEventAttendance' } | { __typename?: 'CourseOptionBooking' } | { __typename?: 'CourseOptionDescriptor' } | { __typename?: 'CoursePart' } | { __typename?: 'CourseParticipationCertificate' } | { __typename?: 'DataProcessingActivity' } | { __typename?: 'DataProcessingAgreementChangeEvent' } | { __typename?: 'DataProcessingProcess' } | { __typename?: 'Document' } | { __typename?: 'DocumentTag' } | { __typename?: 'Expense' } | { __typename?: 'ExpenseDescriptor' } | { __typename?: 'ExpenseReceipt' } | { __typename?: 'MemberPortalUser' } | { __typename?: 'Organization' } | { __typename?: 'OrganizationMembership' } | { __typename?: 'Payment' } | { __typename?: 'Person', id: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined } | { __typename?: 'UserAccount' } };

export type PersonPickerPersonFragment = { __typename?: 'Person', id: string, displayName?: string | null | undefined, email?: { __typename?: 'PersonEmail', emailAddress: string } | null | undefined };

type ResourceLink_AdminAppUser_Fragment = { __typename: 'AdminAppUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } };

type ResourceLink_AuditEvent_Fragment = { __typename: 'AuditEvent', id: string };

type ResourceLink_AuditResource_Fragment = { __typename: 'AuditResource', id: string };

type ResourceLink_Course_Fragment = { __typename: 'Course', name: string, id: string };

type ResourceLink_CourseAdminFile_Fragment = { __typename: 'CourseAdminFile', id: string, adminGroup: { __typename?: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } } };

type ResourceLink_CourseAdminGroup_Fragment = { __typename: 'CourseAdminGroup', name: string, id: string, course: { __typename?: 'Course', name: string, id: string, organization: { __typename?: 'Organization', id: string } } };

type ResourceLink_CourseEvent_Fragment = { __typename: 'CourseEvent', name: string, id: string };

type ResourceLink_CourseEventAttendance_Fragment = { __typename: 'CourseEventAttendance', id: string };

type ResourceLink_CourseOptionBooking_Fragment = { __typename: 'CourseOptionBooking', id: string };

type ResourceLink_CourseOptionDescriptor_Fragment = { __typename: 'CourseOptionDescriptor', name: string, id: string };

type ResourceLink_CoursePart_Fragment = { __typename: 'CoursePart', name: string, id: string };

type ResourceLink_CourseParticipationCertificate_Fragment = { __typename: 'CourseParticipationCertificate', id: string, person: { __typename?: 'Person', id: string }, courseSummary: { __typename?: 'CourseParticipationCourseSummary', level: CourseLevel, part: string, year: number } };

type ResourceLink_DataProcessingActivity_Fragment = { __typename: 'DataProcessingActivity', id: string };

type ResourceLink_DataProcessingAgreementChangeEvent_Fragment = { __typename: 'DataProcessingAgreementChangeEvent', id: string };

type ResourceLink_DataProcessingProcess_Fragment = { __typename: 'DataProcessingProcess', id: string };

type ResourceLink_Document_Fragment = { __typename: 'Document', id: string };

type ResourceLink_DocumentTag_Fragment = { __typename: 'DocumentTag', id: string };

type ResourceLink_Expense_Fragment = { __typename: 'Expense', id: string };

type ResourceLink_ExpenseDescriptor_Fragment = { __typename: 'ExpenseDescriptor', id: string };

type ResourceLink_ExpenseReceipt_Fragment = { __typename: 'ExpenseReceipt', id: string };

type ResourceLink_MemberPortalUser_Fragment = { __typename: 'MemberPortalUser', id: string, person: { __typename?: 'Person', id: string, displayName?: string | null | undefined } };

type ResourceLink_Organization_Fragment = { __typename: 'Organization', name: string, id: string };

type ResourceLink_OrganizationMembership_Fragment = { __typename: 'OrganizationMembership', id: string, person: { __typename?: 'Person', id: string }, organization: { __typename?: 'Organization', id: string, name: string } };

type ResourceLink_Payment_Fragment = { __typename: 'Payment', id: string };

type ResourceLink_Person_Fragment = { __typename: 'Person', displayName?: string | null | undefined, id: string };

type ResourceLink_UserAccount_Fragment = { __typename: 'UserAccount', id: string };

export type ResourceLinkFragment = ResourceLink_AdminAppUser_Fragment | ResourceLink_AuditEvent_Fragment | ResourceLink_AuditResource_Fragment | ResourceLink_Course_Fragment | ResourceLink_CourseAdminFile_Fragment | ResourceLink_CourseAdminGroup_Fragment | ResourceLink_CourseEvent_Fragment | ResourceLink_CourseEventAttendance_Fragment | ResourceLink_CourseOptionBooking_Fragment | ResourceLink_CourseOptionDescriptor_Fragment | ResourceLink_CoursePart_Fragment | ResourceLink_CourseParticipationCertificate_Fragment | ResourceLink_DataProcessingActivity_Fragment | ResourceLink_DataProcessingAgreementChangeEvent_Fragment | ResourceLink_DataProcessingProcess_Fragment | ResourceLink_Document_Fragment | ResourceLink_DocumentTag_Fragment | ResourceLink_Expense_Fragment | ResourceLink_ExpenseDescriptor_Fragment | ResourceLink_ExpenseReceipt_Fragment | ResourceLink_MemberPortalUser_Fragment | ResourceLink_Organization_Fragment | ResourceLink_OrganizationMembership_Fragment | ResourceLink_Payment_Fragment | ResourceLink_Person_Fragment | ResourceLink_UserAccount_Fragment;

export const ResourceLinkFragmentDoc = gql`
    fragment ResourceLink on Node {
  __typename
  id
  ... on Person {
    displayName
  }
  ... on AdminAppUser {
    person {
      id
      displayName
    }
  }
  ... on MemberPortalUser {
    person {
      id
      displayName
    }
  }
  ... on Organization {
    name
  }
  ... on OrganizationMembership {
    person {
      id
    }
    organization {
      id
      name
    }
  }
  ... on Course {
    name
  }
  ... on CoursePart {
    name
  }
  ... on CourseEvent {
    name
  }
  ... on CourseAdminGroup {
    name
    course {
      name
      id
      organization {
        id
      }
    }
  }
  ... on CourseOptionDescriptor {
    name
  }
  ... on CourseAdminFile {
    adminGroup {
      name
      id
      course {
        name
        id
        organization {
          id
        }
      }
    }
  }
  ... on CourseParticipationCertificate {
    person {
      id
    }
    courseSummary {
      level
      part
      year
    }
  }
}
    `;
export const AuditResourceCellFragmentDoc = gql`
    fragment AuditResourceCell on AuditResource {
  id
  resourceId
  resourceType
  resource {
    ...ResourceLink
  }
}
    ${ResourceLinkFragmentDoc}`;
export const AuditEventRowFragmentDoc = gql`
    fragment AuditEventRow on AuditEvent {
  id
  time
  type
  resources {
    classifier
    ...AuditResourceCell
  }
  details
}
    ${AuditResourceCellFragmentDoc}`;
export const OrganizationSettingsDialogCompFragmentDoc = gql`
    fragment OrganizationSettingsDialogComp on Organization {
  id
  name
  officialName
  address {
    addressLine1
    addressLine2
    postalCode
    city
    area
    country
  }
  receiptsFooter
  membershipRequiresContribution
}
    `;
export const AuthServiceUserAccountFragmentDoc = gql`
    fragment AuthServiceUserAccount on UserAccount {
  id
  mfa
  person {
    id
    displayName
    email {
      emailAddress
    }
    adminAppUser {
      id
      roles
      isArchived
    }
  }
}
    `;
export const OrganizationMenuItemFragmentDoc = gql`
    fragment OrganizationMenuItem on Organization {
  id
  name
}
    `;
export const CourseAdminGroupFormCompFragmentDoc = gql`
    fragment CourseAdminGroupFormComp on CourseAdminGroup {
  name
}
    `;
export const EventAttendanceListItemFragmentDoc = gql`
    fragment EventAttendanceListItem on CourseEventAttendance {
  id
  event {
    id
    name
    startDate
    endDate
    part {
      id
      name
    }
  }
  customDuration
}
    `;
export const CreatePaymentDialogFragmentDoc = gql`
    fragment CreatePaymentDialog on CourseOptionBooking {
  id
  expense {
    id
    descriptor {
      id
      amount {
        currency
      }
    }
  }
}
    `;
export const MoneyCompFragmentDoc = gql`
    fragment MoneyComp on Money {
  amount
  currency
}
    `;
export const CourseOptionBookingCompFragmentDoc = gql`
    fragment CourseOptionBookingComp on CourseOptionBooking {
  ...CreatePaymentDialog
  id
  canBeUpdated
  canBeDeleted
  descriptor {
    name
    description
  }
  expense {
    id
    nominal {
      ...MoneyComp
    }
    discount {
      ...MoneyComp
    }
    due {
      ...MoneyComp
    }
    payed {
      ...MoneyComp
    }
    balance {
      ...MoneyComp
    }
    payments {
      id
      method
      receivedAt
      amount {
        ...MoneyComp
      }
    }
  }
}
    ${CreatePaymentDialogFragmentDoc}
${MoneyCompFragmentDoc}`;
export const CourseAdminFileExpenseReceiptFragmentDoc = gql`
    fragment CourseAdminFileExpenseReceipt on ExpenseReceipt {
  id
  databaseId
  generatedAt
  note
  rescinded
}
    `;
export const CourseAdminFileRouteFragmentDoc = gql`
    fragment CourseAdminFileRoute on CourseAdminFile {
  id
  isArchived
  isRescinded
  eventAttendances {
    ...EventAttendanceListItem
  }
  person {
    id
    displayName
  }
  adminGroup {
    id
    isArchived
    optionDescriptors {
      id
      name
    }
    parts {
      id
      events {
        id
      }
    }
  }
  optionBookings {
    ...CourseOptionBookingComp
    expense {
      hasReceipt
    }
  }
  expenseReceipts {
    ...CourseAdminFileExpenseReceipt
  }
  process {
    id
    state
  }
}
    ${EventAttendanceListItemFragmentDoc}
${CourseOptionBookingCompFragmentDoc}
${CourseAdminFileExpenseReceiptFragmentDoc}`;
export const CourseAdminGroupDialogFragmentDoc = gql`
    fragment CourseAdminGroupDialog on CourseAdminGroup {
  id
  name
  isArchived
  parts {
    id
    name
  }
  course {
    id
    parts {
      id
      name
    }
    adminGroups {
      id
      parts {
        id
      }
    }
  }
}
    `;
export const AdminGroupRouteAdminFileFragmentDoc = gql`
    fragment AdminGroupRouteAdminFile on CourseAdminFile {
  id
  isArchived
  isRescinded
  person {
    id
    displayName
    name {
      familyName
      givenName
    }
    email {
      emailAddress
    }
  }
}
    `;
export const CourseAdminGroupRouteFragmentDoc = gql`
    fragment CourseAdminGroupRoute on CourseAdminGroup {
  id
  name
  canBeDeleted
  course {
    id
    name
  }
  parts {
    id
  }
  adminFiles {
    ...AdminGroupRouteAdminFile
  }
  isArchived
}
    ${AdminGroupRouteAdminFileFragmentDoc}`;
export const CourseDialogCourseFragmentDoc = gql`
    fragment CourseDialogCourse on Course {
  id
  name
  level
}
    `;
export const ListPagingControlsFragmentDoc = gql`
    fragment ListPagingControls on Connection {
  pageInfo {
    totalEdges
    totalPages
    page
    size
    hasNextPage
    hasPreviousPage
  }
  edges {
    cursor
  }
}
    `;
export const CourseListItemCompFragmentDoc = gql`
    fragment CourseListItemComp on Course {
  id
  canBeDeleted
  level
  name
  parts {
    id
    name
  }
  adminGroups {
    id
    name
  }
}
    `;
export const CourseListRouteCompFragmentDoc = gql`
    fragment CourseListRouteComp on Organization {
  id
  courses(first: $first, after: $after, last: $last, before: $before) {
    ...ListPagingControls
    courseEdges: edges {
      node {
        ...CourseListItemComp
      }
    }
  }
}
    ${ListPagingControlsFragmentDoc}
${CourseListItemCompFragmentDoc}`;
export const CourseOptionDescriptorFormFragmentDoc = gql`
    fragment CourseOptionDescriptorForm on CourseOptionDescriptor {
  id
  canBeDeleted
  canBeUpdated
  name
  description
  expenseDescriptor {
    id
    amount {
      amount
      currency
    }
  }
}
    `;
export const CourseOptionDescriptorsDialogCompFragmentDoc = gql`
    fragment CourseOptionDescriptorsDialogComp on CourseAdminGroup {
  id
  optionDescriptors {
    ...CourseOptionDescriptorForm
  }
  isArchived
}
    ${CourseOptionDescriptorFormFragmentDoc}`;
export const CoursePartDialogEventFragmentDoc = gql`
    fragment CoursePartDialogEvent on CourseEvent {
  id
  name
  startDate
  endDate
}
    `;
export const CoursePartDialogCoursePartFragmentDoc = gql`
    fragment CoursePartDialogCoursePart on CoursePart {
  id
  name
  startDate
  endDate
  events {
    ...CoursePartDialogEvent
  }
}
    ${CoursePartDialogEventFragmentDoc}`;
export const DocumentTableRowFragmentDoc = gql`
    fragment DocumentTableRow on Document {
  id
  createdAt
  name
  tags {
    id
    name
  }
}
    `;
export const DocumentListPageConnectionFragmentDoc = gql`
    fragment DocumentListPageConnection on DocumentConnection {
  ...ListPagingControls
  documentEdges: edges {
    node {
      ...DocumentTableRow
    }
  }
}
    ${ListPagingControlsFragmentDoc}
${DocumentTableRowFragmentDoc}`;
export const DocumentTagsDialogTagFragmentDoc = gql`
    fragment DocumentTagsDialogTag on DocumentTag {
  id
  name
}
    `;
export const DocumentUploadTagFragmentDoc = gql`
    fragment DocumentUploadTag on DocumentTag {
  id
  name
}
    `;
export const DashboardOrganizationFragmentDoc = gql`
    fragment DashboardOrganization on Organization {
  id
  name
  officialName
  courses(first: 1) {
    pageInfo {
      totalEdges
    }
  }
}
    `;
export const DashboardOrganizationMembershipFragmentDoc = gql`
    fragment DashboardOrganizationMembership on OrganizationMembership {
  id
  startDate
  person {
    id
    databaseId
    displayName
    email {
      emailAddress
    }
  }
}
    `;
export const DashboardOrganizationMembershipsFragmentDoc = gql`
    fragment DashboardOrganizationMemberships on OrganizationMembershipConnection {
  pageInfo {
    hasNextPage
    totalEdges
  }
  edges {
    cursor
    node {
      ...DashboardOrganizationMembership
    }
  }
}
    ${DashboardOrganizationMembershipFragmentDoc}`;
export const CertificateRouteCertificateFragmentDoc = gql`
    fragment CertificateRouteCertificate on CourseParticipationCertificate {
  id
  courseSummary {
    name
    level
    part
    year
    duration
  }
  hasDocument
  completion
  adminFile {
    id
    adminGroup {
      id
      course {
        id
        organization {
          id
        }
      }
    }
  }
}
    `;
export const CertificatesRouteCertificateFragmentDoc = gql`
    fragment CertificatesRouteCertificate on CourseParticipationCertificate {
  id
  courseSummary {
    name
    level
    part
    year
  }
  hasDocument
  completion
}
    `;
export const PostalAddressFormCompFragmentDoc = gql`
    fragment PostalAddressFormComp on PostalAddress {
  addressLine1
  addressLine2
  postalCode
  city
  area
  country
}
    `;
export const CorePersonalDataRouteFragmentDoc = gql`
    fragment CorePersonalDataRoute on Person {
  id
  adminAppUser {
    id
    roles
  }
  displayName
  name {
    canBeDeleted
    givenName
    familyName
  }
  email {
    canBeDeleted
    emailAddress
  }
  phone {
    canBeDeleted
    primaryNumber
    secondaryNumber
  }
  homeAddress {
    canBeDeleted
    address {
      ...PostalAddressFormComp
    }
  }
}
    ${PostalAddressFormCompFragmentDoc}`;
export const DpaRouteActivityFragmentDoc = gql`
    fragment DpaRouteActivity on DataProcessingActivity {
  id
  name
}
    `;
export const DpaRouteChangeEventFragmentDoc = gql`
    fragment DpaRouteChangeEvent on DataProcessingAgreementChangeEvent {
  id
  date
  isManaged
  hasDocumentation
  changes {
    activity {
      ...DpaRouteActivity
    }
    permissionStatus
  }
}
    ${DpaRouteActivityFragmentDoc}`;
export const MembershipRouteMembershipFragmentDoc = gql`
    fragment MembershipRouteMembership on OrganizationMembership {
  id
  startDate
  endDate
  isActive
  organization {
    id
    name
  }
  hasAttachment
}
    `;
export const MembershipsRouteMembershipFragmentDoc = gql`
    fragment MembershipsRouteMembership on OrganizationMembership {
  id
  startDate
  endDate
  isActive
  organization {
    id
    name
  }
}
    `;
export const PersonFiltersFormDpaFragmentDoc = gql`
    fragment PersonFiltersFormDPA on DataProcessingActivity {
  id
  name
}
    `;
export const PersonFiltersFormOrganizationFragmentDoc = gql`
    fragment PersonFiltersFormOrganization on Organization {
  id
  name
}
    `;
export const PersonListRoutePersonFragmentDoc = gql`
    fragment PersonListRoutePerson on Person {
  id
  databaseId
  displayName
}
    `;
export const PersonRouteFragmentDoc = gql`
    fragment PersonRoute on Person {
  id
  displayName
  canBeDeleted
}
    `;
export const ProcessTableProcessFragmentDoc = gql`
    fragment ProcessTableProcess on DataProcessingProcess {
  id
  activity {
    id
    name
  }
  state
  start
  retentionStart
  retentionEnd
  retentionConfig {
    startAdjuster
    duration
    unit
  }
  permissionExists
  resource {
    ...ResourceLink
  }
}
    ${ResourceLinkFragmentDoc}`;
export const ProcessTableFragmentDoc = gql`
    fragment ProcessTable on Person {
  id
  dataProcessingProcesses(after: $after, first: 100) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        ...ProcessTableProcess
      }
    }
  }
}
    ${ProcessTableProcessFragmentDoc}`;
export const UserAccountRouteFragmentDoc = gql`
    fragment UserAccountRoute on Person {
  id
  userAccount {
    id
    mfa
  }
  adminAppUser {
    id
    isArchived
    roles
    process {
      id
      state
    }
  }
  memberPortalUser {
    id
    materialAccessCourseLevels
    process {
      id
      state
    }
  }
}
    `;
export const EntityTimestampsFragmentDoc = gql`
    fragment EntityTimestamps on Timestamped {
  createdAt
  modifiedAt
}
    `;
export const PersonPickerPersonFragmentDoc = gql`
    fragment PersonPickerPerson on Person {
  id
  displayName
  email {
    emailAddress
  }
}
    `;
export const AuditEventsViewerDocument = gql`
    query AuditEventsViewer($first: Int, $after: String, $last: Int, $before: String, $resources: AuditResourceMatchers) {
  auditEvents(
    first: $first
    after: $after
    last: $last
    before: $before
    resources: $resources
  ) {
    ...ListPagingControls
    events: edges {
      node {
        id
        ...AuditEventRow
      }
    }
  }
}
    ${ListPagingControlsFragmentDoc}
${AuditEventRowFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AuditEventsViewerGQL extends Apollo.Query<AuditEventsViewerQuery, AuditEventsViewerQueryVariables> {
    document = AuditEventsViewerDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationSettingsDialogDocument = gql`
    query OrganizationSettingsDialog($id: ID!) {
  node(id: $id) {
    ...OrganizationSettingsDialogComp
  }
}
    ${OrganizationSettingsDialogCompFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationSettingsDialogGQL extends Apollo.Query<OrganizationSettingsDialogQuery, OrganizationSettingsDialogQueryVariables> {
    document = OrganizationSettingsDialogDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizationDocument = gql`
    mutation CreateOrganization($input: CreateOrganizationInput!) {
  createOrganization(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizationGQL extends Apollo.Mutation<CreateOrganizationMutation, CreateOrganizationMutationVariables> {
    document = CreateOrganizationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    ...OrganizationSettingsDialogComp
  }
}
    ${OrganizationSettingsDialogCompFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizationGQL extends Apollo.Mutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables> {
    document = UpdateOrganizationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrganizationDocument = gql`
    mutation DeleteOrganization($id: ID!) {
  deleteOrganization(input: {id: $id})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrganizationGQL extends Apollo.Mutation<DeleteOrganizationMutation, DeleteOrganizationMutationVariables> {
    document = DeleteOrganizationDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePersonDocument = gql`
    mutation CreatePerson {
  createPerson {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePersonGQL extends Apollo.Mutation<CreatePersonMutation, CreatePersonMutationVariables> {
    document = CreatePersonDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAuthServiceUserAccountDocument = gql`
    query GetAuthServiceUserAccount {
  viewerUserAccount {
    ...AuthServiceUserAccount
  }
}
    ${AuthServiceUserAccountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAuthServiceUserAccountGQL extends Apollo.Query<GetAuthServiceUserAccountQuery, GetAuthServiceUserAccountQueryVariables> {
    document = GetAuthServiceUserAccountDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationMenuDocument = gql`
    query OrganizationMenu {
  organizations {
    ...OrganizationMenuItem
  }
}
    ${OrganizationMenuItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationMenuGQL extends Apollo.Query<OrganizationMenuQuery, OrganizationMenuQueryVariables> {
    document = OrganizationMenuDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseAdminFileDocument = gql`
    mutation CreateCourseAdminFile($input: CreateCourseAdminFileInput!) {
  createCourseAdminFile(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseAdminFileGQL extends Apollo.Mutation<CreateCourseAdminFileMutation, CreateCourseAdminFileMutationVariables> {
    document = CreateCourseAdminFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseAdminFileRouteCompDocument = gql`
    query CourseAdminFileRouteComp($id: ID!) {
  node(id: $id) {
    ...CourseAdminFileRoute
  }
}
    ${CourseAdminFileRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseAdminFileRouteCompGQL extends Apollo.Query<CourseAdminFileRouteCompQuery, CourseAdminFileRouteCompQueryVariables> {
    document = CourseAdminFileRouteCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseAdminFileDocument = gql`
    mutation UpdateCourseAdminFile($input: UpdateCourseAdminFileInput!) {
  updateCourseAdminFile(input: $input) {
    ...CourseAdminFileRoute
  }
}
    ${CourseAdminFileRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseAdminFileGQL extends Apollo.Mutation<UpdateCourseAdminFileMutation, UpdateCourseAdminFileMutationVariables> {
    document = UpdateCourseAdminFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseAdminFileDocument = gql`
    mutation DeleteCourseAdminFile($input: DeleteCourseAdminFileInput!) {
  deleteCourseAdminFile(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseAdminFileGQL extends Apollo.Mutation<DeleteCourseAdminFileMutation, DeleteCourseAdminFileMutationVariables> {
    document = DeleteCourseAdminFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseOptionBookingDocument = gql`
    mutation CreateCourseOptionBooking($input: CreateCourseOptionBookingInput!) {
  createCourseOptionBooking(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseOptionBookingGQL extends Apollo.Mutation<CreateCourseOptionBookingMutation, CreateCourseOptionBookingMutationVariables> {
    document = CreateCourseOptionBookingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseAdminFileExpenseReceiptDocument = gql`
    mutation CreateCourseAdminFileExpenseReceipt($input: CreateCourseAdminFileExpenseReceiptInput!) {
  createCourseAdminFileExpenseReceipt(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseAdminFileExpenseReceiptGQL extends Apollo.Mutation<CreateCourseAdminFileExpenseReceiptMutation, CreateCourseAdminFileExpenseReceiptMutationVariables> {
    document = CreateCourseAdminFileExpenseReceiptDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseAdminGroupDialogCompDocument = gql`
    query CourseAdminGroupDialogComp($id: ID!) {
  node(id: $id) {
    ...CourseAdminGroupDialog
  }
}
    ${CourseAdminGroupDialogFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseAdminGroupDialogCompGQL extends Apollo.Query<CourseAdminGroupDialogCompQuery, CourseAdminGroupDialogCompQueryVariables> {
    document = CourseAdminGroupDialogCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseAdminGroupDocument = gql`
    mutation CreateCourseAdminGroup($input: CreateCourseAdminGroupInput!) {
  createCourseAdminGroup(input: $input) {
    ...CourseAdminGroupDialog
  }
}
    ${CourseAdminGroupDialogFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseAdminGroupGQL extends Apollo.Mutation<CreateCourseAdminGroupMutation, CreateCourseAdminGroupMutationVariables> {
    document = CreateCourseAdminGroupDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseAdminGroupDocument = gql`
    mutation UpdateCourseAdminGroup($input: UpdateCourseAdminGroupInput!) {
  updateCourseAdminGroup(input: $input) {
    ...CourseAdminGroupDialog
  }
}
    ${CourseAdminGroupDialogFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseAdminGroupGQL extends Apollo.Mutation<UpdateCourseAdminGroupMutation, UpdateCourseAdminGroupMutationVariables> {
    document = UpdateCourseAdminGroupDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseAdminGroupRouteCompDocument = gql`
    query CourseAdminGroupRouteComp($id: ID!) {
  node(id: $id) {
    ...CourseAdminGroupRoute
  }
}
    ${CourseAdminGroupRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseAdminGroupRouteCompGQL extends Apollo.Query<CourseAdminGroupRouteCompQuery, CourseAdminGroupRouteCompQueryVariables> {
    document = CourseAdminGroupRouteCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseAdminGroupDocument = gql`
    mutation DeleteCourseAdminGroup($id: ID!) {
  deleteCourseAdminGroup(input: {id: $id})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseAdminGroupGQL extends Apollo.Mutation<DeleteCourseAdminGroupMutation, DeleteCourseAdminGroupMutationVariables> {
    document = DeleteCourseAdminGroupDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseAdminGroupIsArchivedDocument = gql`
    mutation UpdateCourseAdminGroupIsArchived($id: ID!, $isArchived: Boolean!) {
  updateCourseAdminGroup(input: {id: $id, isArchived: $isArchived}) {
    id
    isArchived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseAdminGroupIsArchivedGQL extends Apollo.Mutation<UpdateCourseAdminGroupIsArchivedMutation, UpdateCourseAdminGroupIsArchivedMutationVariables> {
    document = UpdateCourseAdminGroupIsArchivedDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ArchiveCourseAdminFileDocument = gql`
    mutation ArchiveCourseAdminFile($id: ID!) {
  updateCourseAdminFile(input: {id: $id, isArchived: true}) {
    id
    isArchived
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ArchiveCourseAdminFileGQL extends Apollo.Mutation<ArchiveCourseAdminFileMutation, ArchiveCourseAdminFileMutationVariables> {
    document = ArchiveCourseAdminFileDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseDialogCompDocument = gql`
    query CourseDialogComp($id: ID!) {
  node(id: $id) {
    ...CourseDialogCourse
  }
}
    ${CourseDialogCourseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseDialogCompGQL extends Apollo.Query<CourseDialogCompQuery, CourseDialogCompQueryVariables> {
    document = CourseDialogCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseDocument = gql`
    mutation CreateCourse($input: CreateCourseInput!) {
  createCourse(input: $input) {
    ...CourseDialogCourse
  }
}
    ${CourseDialogCourseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseGQL extends Apollo.Mutation<CreateCourseMutation, CreateCourseMutationVariables> {
    document = CreateCourseDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseDocument = gql`
    mutation UpdateCourse($input: UpdateCourseInput!) {
  updateCourse(input: $input) {
    ...CourseDialogCourse
  }
}
    ${CourseDialogCourseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseGQL extends Apollo.Mutation<UpdateCourseMutation, UpdateCourseMutationVariables> {
    document = UpdateCourseDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseListRouteDocument = gql`
    query CourseListRoute($organizationId: ID!, $first: Int, $after: String, $last: Int, $before: String) {
  node(id: $organizationId) {
    ...CourseListRouteComp
  }
}
    ${CourseListRouteCompFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseListRouteGQL extends Apollo.Query<CourseListRouteQuery, CourseListRouteQueryVariables> {
    document = CourseListRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseDocument = gql`
    mutation DeleteCourse($id: ID!) {
  deleteCourse(input: {id: $id})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseGQL extends Apollo.Mutation<DeleteCourseMutation, DeleteCourseMutationVariables> {
    document = DeleteCourseDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseOptionBookingDocument = gql`
    mutation UpdateCourseOptionBooking($input: UpdateCourseOptionBookingInput!) {
  updateCourseOptionBooking(input: $input) {
    ...CourseOptionBookingComp
  }
}
    ${CourseOptionBookingCompFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseOptionBookingGQL extends Apollo.Mutation<UpdateCourseOptionBookingMutation, UpdateCourseOptionBookingMutationVariables> {
    document = UpdateCourseOptionBookingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseOptionBookingDocument = gql`
    mutation DeleteCourseOptionBooking($input: DeleteCourseOptionBookingInput!) {
  deleteCourseOptionBooking(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseOptionBookingGQL extends Apollo.Mutation<DeleteCourseOptionBookingMutation, DeleteCourseOptionBookingMutationVariables> {
    document = DeleteCourseOptionBookingDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseOptionBookingPaymentDocument = gql`
    mutation DeleteCourseOptionBookingPayment($input: DeleteCourseOptionBookingPaymentInput!) {
  deleteCourseOptionBookingPayment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseOptionBookingPaymentGQL extends Apollo.Mutation<DeleteCourseOptionBookingPaymentMutation, DeleteCourseOptionBookingPaymentMutationVariables> {
    document = DeleteCourseOptionBookingPaymentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseOptionDescriptorDocument = gql`
    mutation CreateCourseOptionDescriptor($input: CreateCourseOptionDescriptorInput!) {
  createCourseOptionDescriptor(input: $input) {
    ...CourseOptionDescriptorForm
  }
}
    ${CourseOptionDescriptorFormFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseOptionDescriptorGQL extends Apollo.Mutation<CreateCourseOptionDescriptorMutation, CreateCourseOptionDescriptorMutationVariables> {
    document = CreateCourseOptionDescriptorDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseOptionDescriptorDocument = gql`
    mutation UpdateCourseOptionDescriptor($input: UpdateCourseOptionDescriptorInput!) {
  updateCourseOptionDescriptor(input: $input) {
    ...CourseOptionDescriptorForm
  }
}
    ${CourseOptionDescriptorFormFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseOptionDescriptorGQL extends Apollo.Mutation<UpdateCourseOptionDescriptorMutation, UpdateCourseOptionDescriptorMutationVariables> {
    document = UpdateCourseOptionDescriptorDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseOptionDescriptorDocument = gql`
    mutation DeleteCourseOptionDescriptor($input: DeleteCourseOptionDescriptorInput!) {
  deleteCourseOptionDescriptor(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseOptionDescriptorGQL extends Apollo.Mutation<DeleteCourseOptionDescriptorMutation, DeleteCourseOptionDescriptorMutationVariables> {
    document = DeleteCourseOptionDescriptorDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CourseOptionDescriptorsDialogDocument = gql`
    query CourseOptionDescriptorsDialog($id: ID!) {
  node(id: $id) {
    ...CourseOptionDescriptorsDialogComp
  }
}
    ${CourseOptionDescriptorsDialogCompFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CourseOptionDescriptorsDialogGQL extends Apollo.Query<CourseOptionDescriptorsDialogQuery, CourseOptionDescriptorsDialogQueryVariables> {
    document = CourseOptionDescriptorsDialogDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CoursePartDialogCompDocument = gql`
    query CoursePartDialogComp($id: ID!) {
  node(id: $id) {
    ...CoursePartDialogCoursePart
  }
}
    ${CoursePartDialogCoursePartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CoursePartDialogCompGQL extends Apollo.Query<CoursePartDialogCompQuery, CoursePartDialogCompQueryVariables> {
    document = CoursePartDialogCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCoursePartDocument = gql`
    mutation CreateCoursePart($input: CreateCoursePartInput!) {
  createCoursePart(input: $input) {
    ...CoursePartDialogCoursePart
  }
}
    ${CoursePartDialogCoursePartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCoursePartGQL extends Apollo.Mutation<CreateCoursePartMutation, CreateCoursePartMutationVariables> {
    document = CreateCoursePartDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCoursePartDocument = gql`
    mutation UpdateCoursePart($input: UpdateCoursePartInput!) {
  updateCoursePart(input: $input) {
    ...CoursePartDialogCoursePart
  }
}
    ${CoursePartDialogCoursePartFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCoursePartGQL extends Apollo.Mutation<UpdateCoursePartMutation, UpdateCoursePartMutationVariables> {
    document = UpdateCoursePartDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCoursePartDocument = gql`
    mutation DeleteCoursePart($id: ID!) {
  deleteCoursePart(input: {id: $id})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCoursePartGQL extends Apollo.Mutation<DeleteCoursePartMutation, DeleteCoursePartMutationVariables> {
    document = DeleteCoursePartDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseEventDocument = gql`
    mutation CreateCourseEvent($input: CreateCourseEventInput!) {
  createCourseEvent(input: $input) {
    ...CoursePartDialogEvent
  }
}
    ${CoursePartDialogEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseEventGQL extends Apollo.Mutation<CreateCourseEventMutation, CreateCourseEventMutationVariables> {
    document = CreateCourseEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseEventDocument = gql`
    mutation UpdateCourseEvent($input: UpdateCourseEventInput!) {
  updateCourseEvent(input: $input) {
    ...CoursePartDialogEvent
  }
}
    ${CoursePartDialogEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseEventGQL extends Apollo.Mutation<UpdateCourseEventMutation, UpdateCourseEventMutationVariables> {
    document = UpdateCourseEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseEventDocument = gql`
    mutation DeleteCourseEvent($input: DeleteCourseEventInput!) {
  deleteCourseEvent(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseEventGQL extends Apollo.Mutation<DeleteCourseEventMutation, DeleteCourseEventMutationVariables> {
    document = DeleteCourseEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseOptionBookingPaymentDocument = gql`
    mutation CreateCourseOptionBookingPayment($input: CreateCourseOptionBookingPaymentInput!) {
  createCourseOptionBookingPayment(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseOptionBookingPaymentGQL extends Apollo.Mutation<CreateCourseOptionBookingPaymentMutation, CreateCourseOptionBookingPaymentMutationVariables> {
    document = CreateCourseOptionBookingPaymentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseAdminFileExpenseReceiptDocument = gql`
    mutation UpdateCourseAdminFileExpenseReceipt($input: UpdateCourseAdminFileExpenseReceiptInput!) {
  updateCourseAdminFileExpenseReceipt(input: $input) {
    ...CourseAdminFileExpenseReceipt
  }
}
    ${CourseAdminFileExpenseReceiptFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseAdminFileExpenseReceiptGQL extends Apollo.Mutation<UpdateCourseAdminFileExpenseReceiptMutation, UpdateCourseAdminFileExpenseReceiptMutationVariables> {
    document = UpdateCourseAdminFileExpenseReceiptDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseAdminFileExpenseReceiptDocument = gql`
    mutation DeleteCourseAdminFileExpenseReceipt($input: DeleteCourseAdminFileExpenseReceiptInput!) {
  deleteCourseAdminFileExpenseReceipt(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseAdminFileExpenseReceiptGQL extends Apollo.Mutation<DeleteCourseAdminFileExpenseReceiptMutation, DeleteCourseAdminFileExpenseReceiptMutationVariables> {
    document = DeleteCourseAdminFileExpenseReceiptDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentListPageCompDocument = gql`
    query DocumentListPageComp($organizationId: ID!, $first: Int, $after: String, $last: Int, $before: String, $tags: [ID!], $orderBy: DocumentOrderBy!, $orderDirection: OrderDirection!) {
  node(id: $organizationId) {
    ... on Organization {
      documentTags {
        id
        name
        ...DocumentUploadTag
      }
      documents(
        first: $first
        after: $after
        last: $last
        before: $before
        tags: $tags
        orderBy: $orderBy
        orderDirection: $orderDirection
      ) {
        ...DocumentListPageConnection
      }
    }
  }
}
    ${DocumentUploadTagFragmentDoc}
${DocumentListPageConnectionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentListPageCompGQL extends Apollo.Query<DocumentListPageCompQuery, DocumentListPageCompQueryVariables> {
    document = DocumentListPageCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
  updateDocument(input: $input) {
    ...DocumentTableRow
  }
}
    ${DocumentTableRowFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentGQL extends Apollo.Mutation<UpdateDocumentMutation, UpdateDocumentMutationVariables> {
    document = UpdateDocumentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($input: DeleteDocumentInput!) {
  deleteDocument(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentGQL extends Apollo.Mutation<DeleteDocumentMutation, DeleteDocumentMutationVariables> {
    document = DeleteDocumentDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentTagsDialogCompDocument = gql`
    query DocumentTagsDialogComp($organizationId: ID!) {
  node(id: $organizationId) {
    ... on Organization {
      documentTags {
        ...DocumentTagsDialogTag
      }
    }
  }
}
    ${DocumentTagsDialogTagFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentTagsDialogCompGQL extends Apollo.Query<DocumentTagsDialogCompQuery, DocumentTagsDialogCompQueryVariables> {
    document = DocumentTagsDialogCompDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentTagDocument = gql`
    mutation CreateDocumentTag($input: CreateDocumentTagInput!) {
  createDocumentTag(input: $input) {
    ...DocumentTagsDialogTag
  }
}
    ${DocumentTagsDialogTagFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentTagGQL extends Apollo.Mutation<CreateDocumentTagMutation, CreateDocumentTagMutationVariables> {
    document = CreateDocumentTagDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDocumentTagDocument = gql`
    mutation UpdateDocumentTag($input: UpdateDocumentTagInput!) {
  updateDocumentTag(input: $input) {
    ...DocumentTagsDialogTag
  }
}
    ${DocumentTagsDialogTagFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDocumentTagGQL extends Apollo.Mutation<UpdateDocumentTagMutation, UpdateDocumentTagMutationVariables> {
    document = UpdateDocumentTagDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDocumentTagDocument = gql`
    mutation DeleteDocumentTag($input: DeleteDocumentTagInput!) {
  deleteDocumentTag(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDocumentTagGQL extends Apollo.Mutation<DeleteDocumentTagMutation, DeleteDocumentTagMutationVariables> {
    document = DeleteDocumentTagDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationDashboardDocument = gql`
    query OrganizationDashboard($id: ID!) {
  node(id: $id) {
    ...DashboardOrganization
  }
}
    ${DashboardOrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationDashboardGQL extends Apollo.Query<OrganizationDashboardQuery, OrganizationDashboardQueryVariables> {
    document = OrganizationDashboardDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrganizationDashboardMembershipsDocument = gql`
    query OrganizationDashboardMemberships($id: ID!, $first: Int!, $after: String) {
  node(id: $id) {
    ... on Organization {
      id
      memberships(first: $first, after: $after) {
        ...DashboardOrganizationMemberships
      }
    }
  }
}
    ${DashboardOrganizationMembershipsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizationDashboardMembershipsGQL extends Apollo.Query<OrganizationDashboardMembershipsQuery, OrganizationDashboardMembershipsQueryVariables> {
    document = OrganizationDashboardMembershipsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificateRouteDocument = gql`
    query CertificateRoute($certificateId: ID!) {
  node(id: $certificateId) {
    ...CertificateRouteCertificate
  }
}
    ${CertificateRouteCertificateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificateRouteGQL extends Apollo.Query<CertificateRouteQuery, CertificateRouteQueryVariables> {
    document = CertificateRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCourseParticipationCertificateDocument = gql`
    mutation CreateCourseParticipationCertificate($input: CreateCourseParticipationCertificateInput!) {
  createCourseParticipationCertificate(input: $input) {
    ...CertificateRouteCertificate
  }
}
    ${CertificateRouteCertificateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCourseParticipationCertificateGQL extends Apollo.Mutation<CreateCourseParticipationCertificateMutation, CreateCourseParticipationCertificateMutationVariables> {
    document = CreateCourseParticipationCertificateDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCourseParticipationCertificateDocument = gql`
    mutation UpdateCourseParticipationCertificate($input: UpdateCourseParticipationCertificateInput!) {
  updateCourseParticipationCertificate(input: $input) {
    ...CertificateRouteCertificate
  }
}
    ${CertificateRouteCertificateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCourseParticipationCertificateGQL extends Apollo.Mutation<UpdateCourseParticipationCertificateMutation, UpdateCourseParticipationCertificateMutationVariables> {
    document = UpdateCourseParticipationCertificateDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCourseParticipationCertificateDocument = gql`
    mutation DeleteCourseParticipationCertificate($input: DeleteCourseParticipationCertificateInput!) {
  deleteCourseParticipationCertificate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCourseParticipationCertificateGQL extends Apollo.Mutation<DeleteCourseParticipationCertificateMutation, DeleteCourseParticipationCertificateMutationVariables> {
    document = DeleteCourseParticipationCertificateDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CertificatesRouteDocument = gql`
    query CertificatesRoute($personId: ID!) {
  node(id: $personId) {
    ... on Person {
      id
      courseParticipationCertificates {
        ...CertificatesRouteCertificate
      }
    }
  }
}
    ${CertificatesRouteCertificateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CertificatesRouteGQL extends Apollo.Query<CertificatesRouteQuery, CertificatesRouteQueryVariables> {
    document = CertificatesRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CorePersonalDataRouteDocument = gql`
    query CorePersonalDataRoute($personId: ID!) {
  node(id: $personId) {
    ...CorePersonalDataRoute
  }
}
    ${CorePersonalDataRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CorePersonalDataRouteGQL extends Apollo.Query<CorePersonalDataRouteQuery, CorePersonalDataRouteQueryVariables> {
    document = CorePersonalDataRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePersonDocument = gql`
    mutation UpdatePerson($input: UpdatePersonInput!) {
  updatePerson(input: $input) {
    ...CorePersonalDataRoute
  }
}
    ${CorePersonalDataRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePersonGQL extends Apollo.Mutation<UpdatePersonMutation, UpdatePersonMutationVariables> {
    document = UpdatePersonDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DpaRouteActivitesDocument = gql`
    query DpaRouteActivites {
  dataProcessingActivities {
    ...DpaRouteActivity
  }
}
    ${DpaRouteActivityFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DpaRouteActivitesGQL extends Apollo.Query<DpaRouteActivitesQuery, DpaRouteActivitesQueryVariables> {
    document = DpaRouteActivitesDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DpaRouteChangeEventsDocument = gql`
    query DpaRouteChangeEvents($personId: ID!) {
  node(id: $personId) {
    ... on Person {
      id
      dataProcessingAgreementChangeEvents {
        ...DpaRouteChangeEvent
      }
    }
  }
}
    ${DpaRouteChangeEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DpaRouteChangeEventsGQL extends Apollo.Query<DpaRouteChangeEventsQuery, DpaRouteChangeEventsQueryVariables> {
    document = DpaRouteChangeEventsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DpaRouteChangeEventDocument = gql`
    query DpaRouteChangeEvent($eventId: ID!) {
  node(id: $eventId) {
    ...DpaRouteChangeEvent
  }
}
    ${DpaRouteChangeEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DpaRouteChangeEventGQL extends Apollo.Query<DpaRouteChangeEventQuery, DpaRouteChangeEventQueryVariables> {
    document = DpaRouteChangeEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDataProcessingAgreementChangeEventDocument = gql`
    mutation CreateDataProcessingAgreementChangeEvent($input: CreateDataProcessingAgreementChangeEventInput!) {
  createDataProcessingAgreementChangeEvent(input: $input) {
    ...DpaRouteChangeEvent
  }
}
    ${DpaRouteChangeEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDataProcessingAgreementChangeEventGQL extends Apollo.Mutation<CreateDataProcessingAgreementChangeEventMutation, CreateDataProcessingAgreementChangeEventMutationVariables> {
    document = CreateDataProcessingAgreementChangeEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDataProcessingAgreementChangeEventDocument = gql`
    mutation UpdateDataProcessingAgreementChangeEvent($input: UpdateDataProcessingAgreementChangeEventInput!) {
  updateDataProcessingAgreementChangeEvent(input: $input) {
    ...DpaRouteChangeEvent
  }
}
    ${DpaRouteChangeEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDataProcessingAgreementChangeEventGQL extends Apollo.Mutation<UpdateDataProcessingAgreementChangeEventMutation, UpdateDataProcessingAgreementChangeEventMutationVariables> {
    document = UpdateDataProcessingAgreementChangeEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDataProcessingAgreementChangeEventDocument = gql`
    mutation DeleteDataProcessingAgreementChangeEvent($input: DeleteDataProcessingAgreementChangeEventInput!) {
  deleteDataProcessingAgreementChangeEvent(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDataProcessingAgreementChangeEventGQL extends Apollo.Mutation<DeleteDataProcessingAgreementChangeEventMutation, DeleteDataProcessingAgreementChangeEventMutationVariables> {
    document = DeleteDataProcessingAgreementChangeEventDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MembershipRouteDocument = gql`
    query MembershipRoute($membershipId: ID!) {
  node(id: $membershipId) {
    ...MembershipRouteMembership
  }
}
    ${MembershipRouteMembershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MembershipRouteGQL extends Apollo.Query<MembershipRouteQuery, MembershipRouteQueryVariables> {
    document = MembershipRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOrganizaionMembershipDocument = gql`
    mutation UpdateOrganizaionMembership($input: UpdateOrganizationMembershipInput!) {
  updateOrganizationMembership(input: $input) {
    ...MembershipRouteMembership
  }
}
    ${MembershipRouteMembershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOrganizaionMembershipGQL extends Apollo.Mutation<UpdateOrganizaionMembershipMutation, UpdateOrganizaionMembershipMutationVariables> {
    document = UpdateOrganizaionMembershipDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletOrganizaionMembershipDocument = gql`
    mutation DeletOrganizaionMembership($input: DeleteOrganizationMembershipInput!) {
  deleteOrganizationMembership(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletOrganizaionMembershipGQL extends Apollo.Mutation<DeletOrganizaionMembershipMutation, DeletOrganizaionMembershipMutationVariables> {
    document = DeletOrganizaionMembershipDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MembershipsRouteDocument = gql`
    query MembershipsRoute($personId: ID!) {
  node(id: $personId) {
    ... on Person {
      id
      organizationMemberships {
        ...MembershipsRouteMembership
      }
    }
  }
}
    ${MembershipsRouteMembershipFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MembershipsRouteGQL extends Apollo.Query<MembershipsRouteQuery, MembershipsRouteQueryVariables> {
    document = MembershipsRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewMembershipRouteDocument = gql`
    query NewMembershipRoute {
  organizations {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewMembershipRouteGQL extends Apollo.Query<NewMembershipRouteQuery, NewMembershipRouteQueryVariables> {
    document = NewMembershipRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrganizaionMembershipDocument = gql`
    mutation CreateOrganizaionMembership($input: CreateOrganizationMembershipInput!) {
  createOrganizationMembership(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrganizaionMembershipGQL extends Apollo.Mutation<CreateOrganizaionMembershipMutation, CreateOrganizaionMembershipMutationVariables> {
    document = CreateOrganizaionMembershipDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonListRouteDocument = gql`
    query PersonListRoute($first: Int, $after: String, $last: Int, $before: String, $filters: PersonFilters) {
  persons(
    first: $first
    after: $after
    last: $last
    before: $before
    filters: $filters
  ) {
    ...ListPagingControls
    personEdges: edges {
      cursor
      node {
        ...PersonListRoutePerson
      }
    }
  }
  dataProcessingActivities {
    ...PersonFiltersFormDPA
  }
  organizations {
    ...PersonFiltersFormOrganization
  }
}
    ${ListPagingControlsFragmentDoc}
${PersonListRoutePersonFragmentDoc}
${PersonFiltersFormDpaFragmentDoc}
${PersonFiltersFormOrganizationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonListRouteGQL extends Apollo.Query<PersonListRouteQuery, PersonListRouteQueryVariables> {
    document = PersonListRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchFilteredPersonsEmailsDocument = gql`
    query FetchFilteredPersonsEmails($first: Int, $after: String, $filters: PersonFilters) {
  persons(first: $first, after: $after, filters: $filters) {
    pageInfo {
      hasNextPage
    }
    edges {
      cursor
      node {
        id
        email {
          emailAddress
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchFilteredPersonsEmailsGQL extends Apollo.Query<FetchFilteredPersonsEmailsQuery, FetchFilteredPersonsEmailsQueryVariables> {
    document = FetchFilteredPersonsEmailsDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonListRouteSearchDocument = gql`
    query PersonListRouteSearch($query: String!) {
  personSearch(query: $query) {
    ...PersonListRoutePerson
  }
}
    ${PersonListRoutePersonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonListRouteSearchGQL extends Apollo.Query<PersonListRouteSearchQuery, PersonListRouteSearchQueryVariables> {
    document = PersonListRouteSearchDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonRouteDocument = gql`
    query PersonRoute($id: ID!) {
  node(id: $id) {
    ...PersonRoute
  }
}
    ${PersonRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonRouteGQL extends Apollo.Query<PersonRouteQuery, PersonRouteQueryVariables> {
    document = PersonRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePersonDocument = gql`
    mutation DeletePerson($id: ID!) {
  deletePerson(input: {id: $id})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePersonGQL extends Apollo.Mutation<DeletePersonMutation, DeletePersonMutationVariables> {
    document = DeletePersonDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessTableDocument = gql`
    query ProcessTable($personId: ID!, $after: String) {
  node(id: $personId) {
    ...ProcessTable
  }
}
    ${ProcessTableFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessTableGQL extends Apollo.Query<ProcessTableQuery, ProcessTableQueryVariables> {
    document = ProcessTableDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserAccountRouteDocument = gql`
    query UserAccountRoute($personId: ID!) {
  node(id: $personId) {
    ...UserAccountRoute
  }
}
    ${UserAccountRouteFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserAccountRouteGQL extends Apollo.Query<UserAccountRouteQuery, UserAccountRouteQueryVariables> {
    document = UserAccountRouteDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserAccountDocument = gql`
    mutation UpdateUserAccount($input: UpdateUserAccountInput!) {
  updateUserAccount(input: $input) {
    id
    mfa
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserAccountGQL extends Apollo.Mutation<UpdateUserAccountMutation, UpdateUserAccountMutationVariables> {
    document = UpdateUserAccountDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAdminAppUserDocument = gql`
    mutation CreateAdminAppUser($input: CreateAdminAppUserInput!) {
  createAdminAppUser(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAdminAppUserGQL extends Apollo.Mutation<CreateAdminAppUserMutation, CreateAdminAppUserMutationVariables> {
    document = CreateAdminAppUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAdminAppUserDocument = gql`
    mutation UpdateAdminAppUser($input: UpdateAdminAppUserInput!) {
  updateAdminAppUser(input: $input) {
    id
    isArchived
    roles
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAdminAppUserGQL extends Apollo.Mutation<UpdateAdminAppUserMutation, UpdateAdminAppUserMutationVariables> {
    document = UpdateAdminAppUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAdminAppUserDocument = gql`
    mutation DeleteAdminAppUser($input: DeleteAdminAppUserInput!) {
  deleteAdminAppUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAdminAppUserGQL extends Apollo.Mutation<DeleteAdminAppUserMutation, DeleteAdminAppUserMutationVariables> {
    document = DeleteAdminAppUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMemberPortalUserDocument = gql`
    mutation CreateMemberPortalUser($input: CreateMemberPortalUserInput!) {
  createMemberPortalUser(input: $input) {
    id
    materialAccessCourseLevels
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMemberPortalUserGQL extends Apollo.Mutation<CreateMemberPortalUserMutation, CreateMemberPortalUserMutationVariables> {
    document = CreateMemberPortalUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMemberPortalUserDocument = gql`
    mutation UpdateMemberPortalUser($input: UpdateMemberPortalUserInput!) {
  updateMemberPortalUser(input: $input) {
    id
    materialAccessCourseLevels
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMemberPortalUserGQL extends Apollo.Mutation<UpdateMemberPortalUserMutation, UpdateMemberPortalUserMutationVariables> {
    document = UpdateMemberPortalUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMemberPortalUserDocument = gql`
    mutation DeleteMemberPortalUser($input: DeleteMemberPortalUserInput!) {
  deleteMemberPortalUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMemberPortalUserGQL extends Apollo.Mutation<DeleteMemberPortalUserMutation, DeleteMemberPortalUserMutationVariables> {
    document = DeleteMemberPortalUserDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonPickerDocument = gql`
    query PersonPicker($query: String!) {
  personSearch(query: $query) {
    ...PersonPickerPerson
  }
}
    ${PersonPickerPersonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonPickerGQL extends Apollo.Query<PersonPickerQuery, PersonPickerQueryVariables> {
    document = PersonPickerDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PersonPickerByIdDocument = gql`
    query PersonPickerById($id: ID!) {
  node(id: $id) {
    ...PersonPickerPerson
  }
}
    ${PersonPickerPersonFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PersonPickerByIdGQL extends Apollo.Query<PersonPickerByIdQuery, PersonPickerByIdQueryVariables> {
    document = PersonPickerByIdDocument;

    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }